<template>
  <main>
    <div id="reservation">
      <section>
        <div class="container mb-3">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-11 text-center">
              <div class="m-title">
                <h3 style="font-weight:600; text-decoration:underline;">예 약 정 보 확 인</h3>
                <p>
                  <b class="text-danger" v-if="this.reserveInfo.resMFlag === 'N'">(비회원예약)</b>
                </p>
              </div>
              <p class="m-info text-dark">
                <i class="bi bi-music-note-list text-primary"></i> 
                감사합니다 <span v-if="this.reserveInfo.resMFlag != 'N' && memShipName" class="text-success fw-bold">{{ memShipName }} </span>고객님!<br> 순차적인 담당자 확인 후 진행될 예정입니다.<br> 조금만 기다려 주세요!
              </p>

              <!-- 예약상품안내 -->
              <div class="re-check">
                <div class="row col-12">
                  <p class="title" style="text-align: center;">{{ this.productInfo.pdtNameKor }}</p>
                  <table class="table">
                    <tbody>
                      <tr v-if="this.productInfo.salesRoute === 'F'">
                        <th class="name">출발일자</th>
                        <td>{{this.reserveInfo.reqDptDate}}</td>
                      </tr>
                      <tr v-else-if="!this.reserveInfo.reqDptDate || this.reserveInfo.reqDptDate == 'Invalid date'">
                        <th class="name">출발일자</th>
                        <td></td>
                      </tr>
                      <tr v-else>
                        <th class="name">여행기간</th>
                        <td>{{this.reserveInfo.reqDptDate}} ~ {{this.reserveInfo.reqRtnDate}}</td>
                      </tr>

                      <tr>
                        <th class="name">여행지역</th>
                        <td>{{this.productInfo.ntName}} / {{this.productInfo.arName}}</td>
                      </tr>

                      <tr>
                        <th class="name align-middle" rowspan="2">
                          상품옵션
                        </th>
                        <td class="selOpt">
                          <div v-if="this.selOptInfo.length <=0">선택된 옵션이 없습니다.</div>
                          <div v-else>
                            <div :key="i" v-for="(so, i) in this.selOptInfo">
                              {{ so.optName }}&nbsp;&nbsp;({{ so.qty_opt }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}</span> 원)
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="selOpt">
                          <div v-if="this.dirOptInfo.length <=0">직접형 옵션이 없습니다.</div>
                          <div v-else>
                            <div :key="j" v-for="(dio, j) in this.dirOptInfo">
                              {{ dio.odName }}&nbsp;&nbsp;(<span class="text-primary fw-bold">{{ dio.odValue }}</span>)
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr v-if="this.reserveInfo.addPdtFlag === 'Y'">
                        <th class="name align-middle">
                          추가상품
                        </th>
                        <td class="selOpt">
                          <div v-if="this.addPdtInfo.length <=0">선택된 추가상품이 없습니다.</div>
                          <div v-else>
                            <div :key="i" v-for="(so, i) in this.addPdtInfo">
                              {{ so.addPdtName }} ▶ {{ so.addPdtValue }}&nbsp;&nbsp;({{ so.addQty }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}</span> 원)
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr v-if="this.reserveInfo.memDCAmt > 0">
                        <th class="name align-middle">
                          멤버십 할인
                        </th>
                        <td class="selOpt">
                          <span class="text-success fw-bold"> {{ this.getCurrencyFormat(this.reserveInfo.memDCAmt) }}</span>원
                        </td>
                      </tr>

                      <tr v-if="this.reserveInfo.resMFlag != 'N' || this.reserveInfo.resMFlag == null">
                        <th class="name">적립포인트</th>
                        <td>
                          <div v-if="this.productInfo.userPointMethod === 'P'">{{ this.getCurrencyFormat(this.uPoint) }}%</div>
                          <div v-else-if="this.productInfo.userPointMethod === 'A'">{{ this.getCurrencyFormat(this.uPoint) }}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- 예약상품 가격정보 -->
              <div class="re-count">
                <div class="text-center ro-final">
                  <p>결제금액</p>
                  <p class="sum text-danger">{{ this.getCurrencyFormat(this.pdtTotalPrice) }}
                    <font class="text-secondary fs-4">원</font>
                  </p>
                  <hr>
                  <p class="op-ch">(※ 상기금액은 <b>판매조건</b>에 따라 변경될 수 있습니다)</p>
                </div>
              </div>

              <!-- 예약자 정보 -->
              <div class="re-subsc">
                <div class="container">
                  <div class="title text-start">
                    <div style="margin-bottom:1rem">
                      <span>예약자정보</span>
                      <div class="form-check notme">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="this.myselfFlag" true-value="Y" false-value="N" checked>
                        <label class="form-check-label" for="flexCheckDefault">
                          여행자 본인
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="text-start">
                    <table class="table">
                      <!-- 비회원: resMFlag == N -->
                      <tbody v-if="this.reserveInfo.resMFlag === 'N'">
                        <tr>
                          <th class="col-3">예약자</th>
                          <td class="col-7">
                            <input class="form-control" type="text" placeholder="필수, 한글성명(ex.홍길동)" aria-label="한글 성명(ex.홍길동)" v-model="this.resName" ref="resName" maxlength="30">
                          </td>
                        </tr>
                        <tr>
                          <th>연락처</th>
                          <td>
                            <input type="text" class="form-control" placeholder="필수, 모바일연락처(ex.01023456789)" aria-label="모바일연락처(ex.01023456789)" v-model="this.resCall" ref="resCall" maxlength="11">
                          </td>
                        </tr>
                        <tr>
                          <th>이메일</th>
                          <td>
                            <input type="text" class="form-control" placeholder="이메일(ex.abc@def.com)" aria-label="이메일(ex.abc@def.com)" v-model="this.resEmail" ref="resEmail"  maxlength="50">
                          </td>
                        </tr>
                      </tbody>

                      <!-- 회원 -->
                      <tbody v-else>
                        <tr>
                          <th class="col-3">예약자</th>
                          <td class="col-7">
                            <input class="form-control" type="text" placeholder="필수, 한글성명(ex.홍길동)" aria-label="한글 성명(ex.홍길동)" v-model="this.resName" ref="resName" maxlength="30" disabled>
                          </td>
                        </tr>
                        <tr>
                          <th>연락처</th>
                          <td>
                            <input type="text" class="form-control" placeholder="필수, 모바일연락처(ex.01023456789)" aria-label="모바일연락처(ex.01023456789)" v-model="this.resCall" ref="resCall" maxlength="11" disabled>
                          </td>
                        </tr>
                        <tr>
                          <th>이메일</th>
                          <td>
                            <input type="text" class="form-control" placeholder="이메일(ex.abc@def.com)" aria-label="이메일(ex.abc@def.com)" v-model="this.resEmail" ref="resEmail"  maxlength="50" disabled>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="container my-4" v-if="this.myselfFlag === 'N'">
                  <div class="title text-start">
                    <p>
                      여행객정보(
                      <span style="color: crimson; font-size: 0.9rem;"> ⭕여행관련 안내는 예약자에게 발송되므로, 예약자 정보도 반드시 입력되어야 합니다</span>)
                    </p>
                  </div>

                  <div class="text-start">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th class="col-4">대표여행객</th>
                          <td class="col-8">
                            <input class="form-control" type="text" placeholder="한글성명(ex.전우치)" aria-label="한글성명(ex.전우치)" v-model="this.tripName" ref="tripName" maxlength="30">
                          </td>
                        </tr>
                        <tr>
                          <th>연락처</th>
                          <td class="col-8">
                            <input type="text" class="form-control" placeholder="모바일연락처(ex.01023456789)" aria-label="모바일연락처(ex.01023456789)" v-model="this.tripCall" ref="tripCall" maxlength="11">
                          </td>
                        </tr>
                        <tr>
                          <th>이메일</th>
                          <td class="col-8">
                            <input type="text" class="form-control" placeholder="이메일(ex.tester@test.com)" aria-label="이메일(ex.tester@test.com)" v-model="this.tripEmail" ref="tripEmail" maxlength="50">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="container mt-4">
                  <div class="title text-start">
                    <p>기타정보</p>
                  </div>

                  <div class="text-start">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th cclass="col-4">문의사항</th>
                          <td class="col-8">
                            <textarea type="text" class="form-control" ref="ask" placeholder="문의내용을 적어주세요(200자 이내)" v-model="this.askQuestion" maxlength="200" style="height: 150px"></textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="notice text-start">
                  <ul>
                    <li> 여권정보가 필요한 여행 상품의 경우 담당자를 통해 여행자의 여권정보를 수집할 수 있습니다.</li>
                    <li> 고객정보는 여권상 표기된 정보와 일치해야 합니다.(영문성함의 스펠링 등 여권과 상이할 경우 출국이 제한될 수 있습니다.)</li>
                    <li> 여권의 유효기간은 출국일 기준 최소 6개월 이상 여유를 권장합니다.</li>
                    <li> 출입국 등, 여권으로 인한 문제에 대해서는 여행사가 일체 관여하거나 책임지지 않습니다.</li>
                  </ul>
                </div>
              </div>

              <!-- 약관동의 -->
              <div class="re-terms">
                <p class="title">약관 동의</p>
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="this.allConfirmFlag" ref="allConfirmFlag" @change="checkAllConfirm()">
                  <label class="form-check-label" for="defaultCheck">
                    <p>전체 동의</p>
                  </label>
                </div>

                <hr style="border-top:2px solid; opacity:1; margin:0">

                <div class="accordion accordion-flush" id="accordionExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="this.confirm_spTerms" ref="confirm_spTerms">
                        <label class="form-check-label" for="defaultCheck1">
                          <span class="check">[필수]</span>특별약관 설명 및 확인
                        </label>
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        본 여행상품의 최소출발 인원 기준 미충족 시 여행표준약관 제17조에 따라 여행사는 여행출발 7일전까지 여행계약을 일방적으로 해제하고 소비자에게 통보 할 수 있습니다.<br>
                        ※취소수수료의 발생 시점과 부과 기준 정보 고지 본 여행상품은 계약금 지불 시점부터계약이 체결되며,계약해제 요청 시 귀책사유에 따라 취소수수료가 부과됩니다. 취소수수료 부과 기준은 (국외여행표준약관/특별약관)에 따릅니다.<br>
                        <br>
                        -국외여행 특별약관-<br>
                        ･여행 개시 30일 전(~30일) 통보 시 : 전액 환불<br>
                        ･여행 개시 20일 전(29~20일) 통보 시 : 상품가의 20% 공제 후 환불<br>
                        ･여행 개시 10일 전(19~10일) 통보 시 : 상품가의 30% 공제 후 환불<br>
                        ･여행 개시 7일 전(9~7일) 통보 시 : 상품가의 50% 공제 후 환불<br>
                        ･여행 개시 1일 전(6~1일) 통보 시 : 상품가의 70% 공제 후 환불<br>
                        ･여행 개시 당일 통보 시 : 상품가의 100% 공제, 환불 불가<br>
                        단, 여행참가자 수의 미달로 여행 개시 7일전까지 여행계약 해제 통지시: 계약금 100%환불 해드립니다. (본인계좌만 가능)<br>
                        <br>
                        ※ 취소 접수는 업무 시간 내에 유선으로 가능하며, 영업일(월~금-09:00~18:00, 공휴일 제외) 기준입니다.<br>
                        ※ 취소는 출발일 기준에서 제외됩니다.<br>
                        <br>
                        본 여행상품은 항공사의 요청에 의해 항공권이 여행개시 30일전 선발권(구매)이 진행 될 수 있으며 이 경우 고객의 동의 하에 특별약관으로 전환 됩니다.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="this.confirm_Terms" ref="confirm_Terms">
                        <label class="form-check-label" for="defaultCheck2">
                          <span class="check">[필수]</span>약관동의
                        </label>
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        제1조 (목적)<br>
                          이 약관은 엔타비글로벌(주)가 운영하는 엔타비 사이버 몰(이하 "몰"이라 한다)에서 제공하는 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 사이버 몰과 이용자의 권리․의무 및 책임사항을 규정함을 목적으로 합니다.<br>
                          PC통신, 무선 등을 이용하는 전자상거래에 대해서도 그 성질에 반하지 않는 한 이 약관을 준용합니다.<br>
                          <br>
                          제2조 (정의)<br>
                          ① "몰"이란 엔타비 회사가 재화 또는 용역(이하 “재화 등”이라 함)을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 등을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버몰을 운영하는 사업자의 의미로도 사용합니다.<br>
                          ② "이용자"란 "몰"에 접속하여 이 약관에 따라 "몰"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.<br>
                          ③ '회원'이라 함은 "몰"에 회원등록을 한 자로서, 계속적으로 "몰"이 제공하는 서비스를 이용할 수 있는 자를 말합니다.<br>
                          ④ '비회원'이라 함은 회원에 가입하지 않고 "몰"이 제공하는 서비스를 이용하는 자를 말합니다.<br>
                          <br>
                          제3조 (약관 등의 명시와 설명 및 개정)<br>
                          여행의 종류 및 정의, 해외 여행수속 대행업의 정의는 다음과 같습니다.<br>
                          ① "몰"은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호․모사전송번호․전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보관리책임자등을 이용자가 쉽게 알 수 있도록 엔타비 사이버몰의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.<br>
                          ② "몰"은 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회, 배송책임, 환불조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다.<br>
                          ③ "몰"은 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래기본법」, 「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」, 「소비자기본법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br>
                          ④ "몰"이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 몰의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 "몰"은 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.<br>
                          ⑤ "몰"이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다.<br>
                          다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에 "몰"에 송신하여 "몰"의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.<br>
                          ⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한 법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침 및 관계법령 또는 상관례에 따릅니다.<br>
                          <br>
                          제4조 (서비스의 제공 및 변경)<br>
                          ① "몰"은 다음과 같은 업무를 수행합니다.<br>
                            1. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결<br>
                            2. 구매계약이 체결된 재화 또는 용역의 배송<br>
                            3. 기타 "몰"이 정하는 업무<br>
                          ② "몰"은 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및 제공일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지합니다.<br>
                          ③ "몰"이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.<br>
                          ④ 전항의 경우 "몰"은 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.<br>
                          <br>
                          제5조 (서비스의 중단)<br>
                          ① "몰"은 컴퓨터 등 정보통신설비의 보수점검․교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.<br>
                          ② "몰"은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.<br>
                          ③ 사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 "몰"은 제8조에 정한 방법으로 이용자에게 통지하고 당초 "몰"에서 제시한 조건에 따라 소비자에게 보상합니다.<br>
                          다만, "몰"이 보상기준 등을 고지하지 아니한 경우에는 이용자들의 마일리지 또는 적립금 등을 "몰"에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 이용자에게 지급합니다.<br>
                          <br>
                          제6조 (회원가입)<br>
                          ① 이용자는 "몰"이 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.<br>
                          ② "몰"은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.<br>
                            1. 가입신청자가 이 약관 제7조제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 "몰"의 회원재가입 승낙을 얻은 경우에는 예외로 한다.<br>
                            2. 등록 내용에 허위, 기재누락, 오기가 있는 경우<br>
                            3. 기타 회원으로 등록하는 것이 "몰"의 기술상 현저히 지장이 있다고 판단되는 경우<br>
                          ③ 회원가입계약의 성립 시기는 "몰"의 승낙이 회원에게 도달한 시점으로 합니다.<br>
                          ④ 회원은 회원가입 시 등록한 사항에 변경이 있는 경우, 상당한 기간 이내에 "몰"에 대하여 회원정보 수정 등의 방법으로 그 변경사항을 알려야 합니다.<br>
                          <br>
                          제7조 (회원 탈퇴 및 자격 상실 등)<br>
                          ① 회원은 "몰"에 언제든지 탈퇴를 요청할 수 있으며 "몰"은 즉시 회원탈퇴를 처리합니다.<br>
                          ② 회원이 다음 각 호의 사유에 해당하는 경우, "몰"은 회원자격을 제한 및 정지시킬 수 있습니다.<br>
                            1. 가입 신청 시에 허위 내용을 등록한 경우<br>
                            2. "몰"을 이용하여 구입한 재화 등의 대금, 기타 "몰"이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우<br>
                            3. 다른 사람의 "몰" 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우<br>
                            4. "몰"을 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우<br>
                          ③ "몰"이 회원 자격을 제한․정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 "몰"은 회원자격을 상실시킬 수 있습니다.<br>
                          ④ "몰"이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.<br>
                          <br>
                          제8조 (회원에 대한 통지)<br>
                          ① "몰"이 회원에 대한 통지를 하는 경우, 회원이 "몰"과 미리 약정하여 지정한 전자우편 주소로 할 수 있습니다.<br>
                          ② "몰"은 불특정다수 회원에 대한 통지의 경우 1주일이상 "몰" 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.<br>
                          <br>
                          제9조 (구매신청 및 개인정보 제공 동의 등)<br>
                          ① "몰"이용자는 "몰"상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, "몰"은 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.<br>
                            1. 재화 등의 검색 및 선택<br>
                            2. 받는 사람의 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력<br>
                            3. 약관내용, 청약철회권이 제한되는 서비스, 배송료․설치비 등의 비용부담과 관련한 내용에 대한 확인<br>
                            4. 이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)<br>
                            5. 재화등의 구매신청 및 이에 관한 확인 또는 "몰"의 확인에 대한 동의<br>
                            6. 결제방법의 선택<br>
                          ② "몰"이 제3자에게 구매자 개인정보를 제공할 필요가 있는 경우<br>
                            1) 개인정보를 제공받는 자<br>
                            2)개인정보를 제공받는 자의 개인정보 이용목적<br>
                            3) 제공하는 개인정보의 항목<br>
                            4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간을 구매자에게 알리고 동의를 받아야 합니다. (동의를 받은 사항이 변경되는 경우에도 같습니다.)<br>
                          ③ "몰"이 제3자에게 구매자의 개인정보를 취급할 수 있도록 업무를 위탁하는 경우에는 개인정보 취급위탁을 받는 자, 개인정보 취급위탁을 하는 업무의 내용을 구매자에게 알리고 동의를 받아야 합니다. (동의를 받은 사항이 변경되는 경우에도 같습니다.)<br>
                          다만, 서비스제공에 관한 계약이행을 위해 필요하고 구매자의 편의증진과 관련된 경우에는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」에서 정하고 있는 방법으로 개인정보 취급방침을 통해 알림으로써 고지절차와 동의절차를 거치지 않아도 됩니다.<br>
                          <br>
                          제10조 (계약의 성립)<br>
                          ① "몰"은 제9조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.<br>
                            1. 신청 내용에 허위, 기재누락, 오기가 있는 경우<br>
                            2. 미성년자가 담배, 주류 등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우<br>
                            3. 기타 구매신청에 승낙하는 것이 "몰" 기술상 현저히 지장이 있다고 판단하는 경우<br>
                          ② "몰"의 승낙이 제12조제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.<br>
                          ③ "몰"의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매가능 여부, 구매신청의 정정 취소 등에 관한 정보 등을 포함하여야 합니다.<br>
                          <br>
                          제11조 (지급방법)<br>
                          "몰"에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각 호의 방법중 가용한 방법으로 할 수 있습니다. 단, "몰"은 이용자의 지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다.<br>
                            1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체<br>
                            2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제<br>
                            3. 온라인무통장입금<br>
                            4. 전자화폐에 의한 결제<br>
                            5. 수령 시 대금지급<br>
                            6. 마일리지 등 "몰"이 지급한 포인트에 의한 결제<br>
                            7. "몰"과 계약을 맺었거나 "몰"이 인정한 상품권에 의한 결제<br>
                            8. 기타 전자적 지급 방법에 의한 대금 지급 등<br>
                            <br>
                          제12조 (수신확인 톨지, 구매신청 변경 및 취소)<br>
                          ① "몰"은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.<br>
                          ② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 "몰"은 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한 경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다.<br>
                          <br>
                          제13조 (재화 등의 공급)<br>
                          ① "몰"은 이용자와 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, "몰"이 이미 재화 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 3영업일 이내에 조치를 취합니다. 이때 "몰"은 이용자가 재화 등의 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.<br>
                          ② "몰"은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 "몰"이 약정 배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상하여야 합니다. 다만 "몰"이 고의․과실이 없음을 입증한 경우에는 그러하지 아니합니다.<br>
                          <br>
                          제14조 (환급)<br>
                          "몰"은 이용자가 구매신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.<br>
                          <br>
                          제15조 (청약철회 등)<br>
                          ① "몰"과 재화등의 구매에 관한 계약을 체결한 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제13조 제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의 공급이 늦게 이루어진 경우에는 재화 등을 공급받거나 재화 등의 공급이 시작된 날을 말합니다)부터 7일 이내에는 청약의 철회를 할 수 있습니다. 다만, 청약철회에 관하여 「전자상거래 등에서의 소비자보호에 관한 법률」에 달리 정함이 있는 경우에는 동 법 규정에 따릅니다.<br>
                          ② 이용자는 재화 등을 배송 받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.<br>
                            1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있습니다)<br>
                            2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우<br>
                            3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한 경우<br>
                            4. 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우<br>
                          ③ 제2항제2호 내지 제4호의 경우에 "몰"이 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회 등이 제한되지 않습니다.<br>
                          ④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.<br>
                          <br>
                          제16조 (청약철회 등의 효과)<br>
                          ① "몰"은 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다. 이 경우 "몰"이 이용자에게 재화등의 환급을 지연한때에는 그 지연기간에 대하여 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」제21조의2에서 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.<br>
                          ② "몰"은 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다.<br>
                          ③ 청약철회 등의 경우 공급받은 재화 등의 반환에 필요한 비용은 이용자가 부담합니다. "몰"은 이용자에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 재화 등의 반환에 필요한 비용은 "몰"이 부담합니다.<br>
                          ④ 이용자가 재화 등을 제공받을 때 발송비를 부담한 경우에 "몰"은 청약철회 시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게 표시합니다.<br>
                          <br>
                          제17조 (개인정보 보호)<br>
                          ① "몰"은 이용자의 개인정보 수집시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.<br>
                          ② "몰"은 회원가입시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다.<br>
                          ③ "몰"은 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.<br>
                          ④ "몰"은 수집된 개인정보를 목적외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다.<br>
                          ⑤ "몰"이 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은자, 제공목적 및 제공할 정보의 내용) 등 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제22조제2항이 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.<br>
                          ⑥ 이용자는 언제든지 "몰"이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 "몰"은 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 "몰"은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.<br>
                          ⑦ "몰"은 개인정보 보호를 위하여 이용자의 개인정보를 취급하는 자를 최소한으로 제한하여야 하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.<br>
                          ⑧ "몰" 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.<br>
                          ⑨ "몰"은 개인정보의 수집·이용·제공에 관한 동의 란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집·이용·제공에 관한 이용자의 동의거절시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이 아닌 개인정보의 수집·이용·제공에 관한 이용자의 동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다.<br>
                          <br>
                          제18조 ("몰"의 의무)<br>
                          ① "몰"은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화․용역을 제공하는데 최선을 다하여야 합니다.<br>
                          ② "몰" 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.<br>
                          ③ "몰"이 상품이나 용역에 대하여 「표시․광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시․광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.<br>
                          ④ "몰"은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.<br>
                          <br>
                          제19조 (회원의 ID 및 비밀번호에 대한 의무)<br>
                          ① 제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.<br>
                          ② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.<br>
                          ③ 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 "몰"에 통보하고 "몰"의 안내가 있는 경우에는 그에 따라야 합니다.<br>
                          <br>
                          제20조 (이용자의 의무)<br>
                          이용자는 다음 행위를 하여서는 안 됩니다.<br>
                            1. 신청 또는 변경시 허위 내용의 등록<br>
                            2. 타인의 정보 도용<br>
                            3. "몰"에 게시된 정보의 변경<br>
                            4. "몰"이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시<br>
                            5. "몰" 기타 제3자의 저작권 등 지적재산권에 대한 침해<br>
                            6. "몰" 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br>
                            7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 몰에 공개 또는 게시하는 행위<br>
                            <br>
                          제21조 (연결 "몰"과 피연결 "몰" 간의 관계)<br>
                          ① 상위 "몰"과 하위 "몰"이 하이퍼링크(예: 하이퍼링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우, 전자를 연결 "몰"(웹 사이트)이라고 하고 후자를 피연결 "몰"(웹사이트)이라고 합니다.<br>
                          ② 연결"몰"은 피연결"몰"이 독자적으로 제공하는 재화 등에 의하여 이용자와 행하는 거래에 대해서 보증 책임을 지지 않는다는 뜻을 연결"몰"의" 초기화면 또는 연결되는 시점의 팝업화면으로 명시한 경우에는 그 거래에 대한 보증 책임을 지지 않습니다.<br>
                          <br>
                          제22조 (저작권의 귀속 및 이용제한)<br>
                          ① "몰"이 작성한 저작물에 대한 저작권 기타 지적재산권은 '몰'에 귀속합니다.<br>
                          ② 이용자는 "몰"을 이용함으로써 얻은 정보 중 "몰"에게 지적재산권이 귀속된 정보를 "몰"의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.<br>
                          ③ "몰"은 약정에 따라 이용자에게 귀속된 저작권을 사용하는 경우 당해 이용자에게 통보하여야 합니다.<br>
                          <br>
                          제23조 (분쟁해결)<br>
                          ① "몰"은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치․운영합니다.<br>
                          ② "몰"은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.<br>
                          ③ "몰"과 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.<br>
                          <br>
                          제24조 (재판권 및 준거법)<br>
                          ① "몰"과 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.<br>
                          ② "몰"과 이용자 간에 제기된 전자상거래 소송에는 한국법을 적용합니다.<br>

                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="this.confirm_Info" ref="confirm_Info">
                        <label class="form-check-label" for="defaultCheck3">
                          <span class="check">[필수]</span>개인정보 수집 및 이용동의
                        </label>
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        엔타비 글로벌 (이하 '엔타비')는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.<br>

                        1. 개인정보 수집 및 이용목적<br>
                        엔타비는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.<br>
                        &nbsp; 1) 홈페이지 회원가입 및 관리<br>
                        &nbsp; 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 만14세 미만 아동 개인정보 수집 시 법정대리인 동의 여부 확인, 각종 고지·통지, 분쟁 조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.<br>
                        &nbsp; 2) 서비스 제공<br>
                        &nbsp;  물품배송, 서비스 제공, 청구서 발송, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.<br>
                        &nbsp; 3) 마케팅 및 광고에의 활용<br>
                        &nbsp; 신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공 , 인구통계학적 특성에 따른 서비스 제공 및 광고 게재 , 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.<br>
                        <br>
                        2. 개인정보 수집 항목<br>
                        엔타비는 다음의 개인정보 항목을 처리하고 있습니다.<br>
                        &nbsp; 1) 홈페이지 회원가입 및 관리/마케팅 정보 제공의 목적 (회원탈퇴 시 까지)<br>
                        &nbsp;  이메일, 휴대전화번호, 자택주소, 비밀번호, 로그인ID, 성별, 생년월일, 이름<br>
                        &nbsp; 2) 상담 및 해외 및 국내 여행 예약의 목적 (신용카드정보, 은행계좌정보)<br>
                        &nbsp;  이메일, 휴대전화번호, 자택주소, 비밀번호, 로그인ID, 성별, 생년월일, 이름, 여권사본, 법정대리인 이름, 법정대리인 자택 전화번호, 법정대리인 자택 주소, 법정대리인 휴대전화번호<br>
                        &nbsp; 3) 여행자 보험가입의 목적 (신용카드정보, 은행계좌정보)<br>
                        &nbsp;  이메일, 휴대전화번호, 자택주소, 성별, 생년월일, 이름<br>
                        &nbsp; 4) 대금결제의 목적 (이용목적이 달성되면 파기)<br>
                        &nbsp;  신용카드정보, 은행계좌정보<br>
                          <br>
                        3. 개인정보 수집 항목 보유 및 이용기간<br>
                        &nbsp; 1) 엔타비는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 처리,보유합니다.<br>
                        &nbsp; 2) 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br>
                        &nbsp;  ① 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년<br>
                        &nbsp;  ② 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년<br>
                        &nbsp;  ③ 대금결제 및 재화 등의 공급에 관한 기록 : 5년<br>
                        &nbsp;  ④ 계약 또는 청약철회 등에 관한 기록 : 5년<br>
                        &nbsp;  ⑤ 표시/광고에 관한 기록 : 6개월<br>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="this.confirm_Privacy" ref="confirm_Privacy">
                        <label class="form-check-label" for="defaultCheck4">
                          <span class="check">[필수]</span>고유식별정보 수집 및 이용동의
                        </label>
                      </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        고유식별정보 동의 안내<br>
                        <br>
                        당사는 개인정보보호법을 준수하며 서비스 수행의 목적에 한하여 최소한의 고유식별정보를 수집,이용하며 기준은 아래와 같습니다.<br>
                        1. 고유식별 정보 수집/이용 목적 : 해외여행 상품예약시 출국가능 여부파악 및 여행자 본인식별, 여행자보험 가입<br>
                        2. 수집하는 고유식별 정보의 항목 : 여권번호 (여권만료일)<br>
                        3. 고유식별정보의 보유 및 이용기간 : 여행상품 서비스 수행목적의 완료시점까지<br>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                        <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="this.confirm_3rd" ref="confirm_3rd">
                        <label class="form-check-label" for="defaultCheck5">
                          <span class="check">[필수]</span>개인정보 3자제공
                        </label>
                      </button>
                    </h2>
                    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        '엔타비'는 고객(동반자포함) 개인정보의 보호를 위하여 당사가 보관하고 있는 고객의 개인정보를 제3자와 공유하거나 무단으로 제공하지 않습니다. <br>
                        여행상품의 예약 및 원활한 여행서비스 제공 등을 위한 목적으로 고객의 개인정보 중 일부가 제3자에게 제공될 수 있습니다.(개인정보를 제공받는 업체, 개인정보 항목, 이용 목적 및 이용기간 추후 변동될 수 있습니다.)<br>
                        서비스 제공에 관한 계약의 이행을 위하여 필요한 개인정보로서 경제적 기술적인 사유로 통상의 동의를 받는 것이 현저히 곤란한 경우나 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우에는 고객의 동의 없이 개인정보를 제공할 수 있습니다.
                        <br>
                        '엔타비'는 고객(동반자포함)의 개인정보가 본래의 수집 목적 및 이용 목적에 반하여 무분별하게 사용되지 않도록 최선의 노력을 다할 것입니다.<br>
                        1) 엔타비는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.<br>
                        2) 엔타비는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.<br>
                        &nbsp;① 항공사/선박업체/여행업체/은행·카드 CP사/비자발급대행사/인솔자(여행을 다녀온 시점에 즉시 파기)<br>
                        &nbsp; &nbsp;> 콘텐츠 제공, 구매 및 요금 결제,개인 식별, 불만처리 등 민원처리, 고지사항 전달<br>
                        &nbsp; &nbsp;> 성명(국/영문), 여권 및 비자 사본, 전화번호, 주소, 회원 종류 위탁<br>
                        &nbsp;② 숙박업체<br>
                        &nbsp; &nbsp;> 숙박 예약 및 개인 식별의 목적<br>
                        &nbsp; &nbsp;> 성명(국/영문), 여권 및 비자 사본, 전화번호<br>
                        &nbsp;③ 토파스<br>
                        &nbsp; &nbsp;> 항공권 카드 결제의 목적<br>
                        &nbsp; &nbsp;> 성명(국/영문), 여권 및 비자 사본, 전화번호, 카드사명, 카드번호, 카드유효기간 위탁<br>
                        &nbsp;④ 현대해상, 메리츠화재, KB손해보험<br>
                        &nbsp; &nbsp;> 여행자 보험가입의 목적<br>
                        &nbsp; &nbsp;> 한글명, 영문명, 주민번호<br>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 필수확인사항 -->
              <div class="re-result">
                <div class="row justify-content-center">
                  <div class="col-12 col-lg-10 bg-light">
                    <div class="incont">
                      <p>필수 확인 사항</p>
                      <ul>
                        <li>- 예약 후 결제 완료, 예약 확정 시 취소 시점에 따라 위약금이 발생할 수 있습니다.</li>
                        <li>- 취소위약금 규정은 각 상품 상세 페이지에서 확인가능합니다.</li>
                        <li>- 예약 완료 후 즉시 확정이 아니며 담당자 확인 전화로 추가 안내 및 예악 확인 절차가 진행됩니다.</li>
                        <li>- 여행 상품의 특성상 경우에 따라 예약이 완료된 후에도 처리가 불가능 할 수 있습니다.</li>
                        <li>- 여행상품의 약관 규정은 재경부 고시 소비자 피해보상 규정을 바탕으로 하나, 특정 상품의 경우 엔타비글로벌 특별 약관을 적용하고 있습니다.</li>
                        <li>- 특별한 안내가 있는 경우를 제외하고, <u>쿠폰과 포인트는 같이 사용하실 수 없습니다.</u></li>                        
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="re-result" v-if="(this.userCouponInfo.length > 0 && showCpArea) || (showPtArea && this.availPoint > 0)">
                <div class="row justify-content-center">
                  <div class="col-12 col-lg-10 bg-light">
                    <div class="incont">
                      <i class="bi bi-check-lg text-danger"></i> 쿠폰과 포인트는 같이 사용하실 수 없습니다<br>
                      <i class="bi bi-check-lg text-danger"></i> 선택하신 쿠폰 또는 포인트 할인은, 전체금액 중 할인적용 대상이 되는 금액에 적용이 됩니다<br>
                      <i class="bi bi-check-lg text-danger"></i> 예약금 결제 시에도 상기의 할인이 우선 적용된 후, 결제금액이 표시됩니다<br>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 가용쿠폰리스트 -->
              <div v-if="this.userCouponInfo.length > 0 && showCpArea">
                <div v-if="this.userCouponInfo.length > 0">  
                  <div class="mt-5 row justify-content-center">
                    <table class="couponTB" style="border: solid 1px; border-color: lightgrey; border-radius: 12%;">
                      <th class="cpThName" style="width: 15%; vertical-align: middle; text-align: center;">
                        쿠폰
                      </th>
                      <td>
                        <div class="d-flex justify-content-left noCoupon" style="padding-top: 7px; padding-bottom: 0px;"  @click="choiceCoupon('', 'Y', 0, 'A')">
                          <p style="width: 3%; padding-top: 5px;">
                            <input class="form-check-input" type="radio" name="selectCoupon" :disabled="paymentDisabled">
                          </p>
                          <p style="padding-left: 5px; padding-top: 5px;">쿠폰을 사용하지 않습니다(쿠폰사용취소)</p>
                        </div>

                        <hr style="border-style: solid 2px gray; margin:5px;">

                        <div :key="i" v-for="(cp, i) in this.userCouponInfo" @click="choiceCoupon(cp.cpCode, cp.cpWithPoint, cp.cpPrice, cp.cpPriceFlag, cp.cpSubNo)">
                          <div v-if="cp.canPay == 'Y'"  class="d-flex justify-content-left" style="padding-top: 7px; padding-bottom: 0px;">
                            <p style="width: 3%;">
                              <input class="form-check-input" type="radio" :value="cp.cpCode" name="selectCoupon" v-model="this.selCoupon" :disabled="paymentDisabled">
                            </p>
                            <p class="cpInfo" style="margin-left: 5px; width: 40%; text-align: start;">
                              {{ cp.cpName }}&nbsp;
                              <span style="color:gray;">({{ cp.cpCode }})</span>
                            </p>

                            <span class="couponPrice" style="width:10%; color: blue;">
                              <p v-if="cp.cpPriceFlag === 'A'">
                                {{ this.getCurrencyFormat(cp.cpPrice) }}<span style="font-size:0.8rem; color:black;">원</span>
                              </p>
                              <p v-else>
                                {{ this.getCurrencyFormat(cp.cpPrice) }}<span style="font-size:0.8rem; color:black;">%</span>
                              </p>
                            </span>

                            <p class="couponExp" style="width:15%;">{{ this.getDateFormat(cp.cpExpDate) }}까지</p>

                            <pre class="couponRm" style="width:32%; text-align: left; padding-left: 20px;" v-if="!cp.memCpFlag">{{ cp.cpRemarks }}</pre>
                            <pre class="couponRm" style="width:32%; text-align: left; padding-left: 20px;" v-else>{{ cp.pContent }}</pre>
                            <hr style="border-style: solid 2px gray; margin:5px;">                            
                          </div>
                        </div>
                      </td>
                    </table>
                  </div>
                </div>
              </div>

              <!-- 포인트결제정보 -->
              <div class="mt-5 row justify-content-center" v-if="showPtArea && this.availPoint > 0">
                <div class="input-group" style="height: 50px; width: 90%;">
                  <span class="input-group-text availPoint" style="width: auto;">
                    가용포인트<b style="color:blue;">&nbsp;({{ this.getCurrencyFormat(this.availPoint) }})</b>
                  </span>
                  <input type="number" class="form-control text-end" min="0" :max=this.availPoint style="color:red; font-weight:600;" v-model="this.pPoint" ref="pPoint" :disabled="paymentDisabled" :readonly="this.pPointFixFlag == 'Y'">
                  <button type="button" class="btn btn-primary usePBtn" style="width:auto;" @click="payByAvailPoint(this.pPoint);" v-if="this.pPointFixFlag === 'N'" :disabled="paymentDisabled">사용</button>
                  <button type="button" class="btn btn-warning cxlPBtn" style="width:auto;" @click="makeDefpPoint();" v-else>취소</button>
                </div>
              </div>

              <!-- 버튼 -->
              <div class="mt-0 row justify-content-center" v-if="this.mainButton">
                <button class="btn cxl col-5 col-lg-3 mx-2"  @click="goToList()">메인페이지로</button>
                <button class="btn go col-5 col-lg-3 mx-2" data-bs-target="#reservationDone" @click="reserComplete(this.reqRsvCode, 'fu')">예약하기</button>
                <button class="btn part col-5 col-lg-3 mx-2" data-bs-target="#reservationDone" @click="reserComplete(this.reqRsvCode, 'p1')" v-if="productInfo.firstPayment > '0' && productInfo.firstPayment < '100'">예약금결제</button>
              </div>
              <div class="mt-0 row justify-content-center" v-else>
              </div>

              <!-- 결제선택버튼 -->
              <div class="text-end selPayBtn" v-show="payButton">  
                <div v-if="this.payCoupon > 0">
                  <button @click="requestPayment(this.reqRsvCode, this.reserveInfo.resMFlag, this.payStyle, this.firstPayment)" class="btn btn-success" id="payment-button">
                    <b v-if="this.payStyle === 'fu'">
                      <i class="bi bi-credit-card"></i> 전액결제선택 ({{ this.getCurrencyFormat(this.firstPayment) }}원)
                    </b>
                    <b v-else-if="this.payStyle === 'p1'">
                      <i class="bi bi-credit-card"></i> 부분결제선택 ({{ this.getCurrencyFormat(this.firstPayment) }}원)
                    </b>
                    <b v-else>결제선택이 불분명합니다</b>
                  </button>
                  <button @click="cxlPayment()" class="btn btn-secondary" style="margin-left: 10px;">결 제 취 소</button>
                </div>

                <div v-else-if="this.pPoint > 0 && this.pPointFixFlag === 'Y'">
                  <button @click="requestPayment(this.reqRsvCode, this.reserveInfo.resMFlag, this.payStyle, this.firstPayment)" class="btn btn-success" id="payment-button">
                    <b v-if="this.payStyle === 'fu'">
                      <i class="bi bi-credit-card"></i> 전액결제선택 ({{ this.getCurrencyFormat(this.firstPayment) }}원)
                    </b>
                    <b v-else-if="this.payStyle === 'p1'">
                      <i class="bi bi-credit-card"></i> 부분결제선택 ({{ this.getCurrencyFormat(this.firstPayment) }}원)
                    </b>
                    <b v-else>결제선택이 불분명합니다</b>
                  </button>
                  <button @click="cxlPayment()" class="btn btn-secondary" style="margin-left: 10px;">결 제 취 소</button>
                </div>
                <div v-else>
                  <button @click="requestPayment(this.reqRsvCode, this.reserveInfo.resMFlag, this.payStyle, this.firstPayment)" class="btn btn-success" id="payment-button">
                    <b v-if="this.payStyle === 'fu'">
                      <i class="bi bi-credit-card"></i> 전액결제선택 ({{ this.getCurrencyFormat(this.firstPayment) }}원)
                    </b>
                    <b v-else-if="this.payStyle === 'p1'">
                      <i class="bi bi-credit-card"></i> 부분결제선택 ({{ this.getCurrencyFormat(this.firstPayment) }}원)
                    </b>
                    <b v-else>결제선택이 불분명합니다</b>
                  </button>
                  <button @click="cxlPayment()" class="btn btn-secondary" style="margin-left: 10px;">결 제 취 소</button>
                </div>
              </div>

              <hr class="mt-5 mb-3">

              <div id="payment-method" class="mt-1" v-show="showFlag" style="height:auto"></div>

              <div style="text-align:center; padding-right: 35px;"  v-show="showFlag">
                <div v-if="this.payCoupon > 0">
                  <button @click="doPay()" class="btn btn-primary" id="payment-button" style="width:80%">
                    <b class="fs-5" v-if="this.payStyle === 'fu'">
                      <i class="bi bi-credit-card"></i> 전액결제하기 ({{ this.getCurrencyFormat(firstPayment) }}원)
                    </b>
                    <b class="fs-5" v-else-if="this.payStyle === 'p1'">
                      <i class="bi bi-credit-card"></i> 부분결제하기 ({{ this.getCurrencyFormat(firstPayment) }}원)
                    </b>
                    <b class="fs-5" v-else>결제선택이 불분명합니다</b>
                  </button>
                </div>

                <div v-else-if="this.pPoint > 0 && this.pPointFixFlag === 'Y'">
                  <button @click="doPay()" class="btn btn-primary" id="payment-button" style="width:80%">
                    <b class="fs-5" v-if="this.payStyle === 'fu'">
                      <i class="bi bi-credit-card"></i> 전액결제하기 ({{ this.getCurrencyFormat(firstPayment) }}원)
                    </b>
                    <b class="fs-5" v-else-if="this.payStyle === 'p1'">
                      <i class="bi bi-credit-card"></i> 부분결제하기 ({{ this.getCurrencyFormat(firstPayment) }}원)
                    </b>
                    <b class="fs-5" v-else>결제선택이 불분명합니다</b>
                  </button>
                </div>
                <div v-else>
                  <button @click="doPay()" class="btn btn-primary" id="payment-button" style="width:80%">
                    <b class="fs-5" v-if="this.payStyle === 'fu'">
                      <i class="bi bi-credit-card"></i> 전액결제하기 ({{ this.getCurrencyFormat(firstPayment) }}원)
                    </b>
                    <b class="fs-5" v-else-if="this.payStyle === 'p1'">
                      <i class="bi bi-credit-card"></i> 부분결제하기 ({{ this.getCurrencyFormat(firstPayment) }}원)
                    </b>
                    <b class="fs-5" v-else>결제선택이 불분명합니다</b>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { loadPaymentWidget, ANONYMOUS } from "@tosspayments/payment-widget-sdk";
import { handlerInfo } from '../assets/js/commonFunctions'
import moment from 'moment';
import { getActiveBlock } from '../assets/js/reservationBlock'   // [임시] 예약차단 - 정규화 시 제거

export default {
  data() {
    return {
      paymentDisabled: false,     // 결제관련 정보입력 비활성화 여부
      showFlag: false,            //결제창 표시여부

      // 토스PG결제용 정보
      paymentWidget: null,
      paymentMethodWidget: null,
      clientKey: "live_ck_jZ61JOxRQVEZXa1aoR0rW0X9bAqw",
      customerKey: "Ntabi-1936=@",

      productInfo: [],              //상품정보
      reserveInfo: [],              //예약정보
      selOptInfo: [],               //선택형옵션정보
      dirOptInfo: [],               //직접형옵션정보

      selOptFlag: "N",              //선택옵션유무
      dirOptFlag: "N",              //선택옵션유무

      pdtTotalPrice: 0,             //상품총금액

      productPrice: [],             //기본상품금액정보
      startingPrice: 0,             //최초세팅가격
      dcPrice: 0,                   //할인수치
      dcMethod: "",                 //할인방법(P/A)
      basicPrice: 0,                //기본상품금액

      myselfFlag: "Y",              //본인여부(Y/N)

      resName: "",                  //예약자명
      resCall: "",                  //예약자연락처
      resEmail: "",                 //예약자이메일
      tripName: "",                 //대표여행객
      tripCall: "",                 //대표여행객
      tripEmail: "",                //대표여행객

      askQuestion: "",              //기타문의사항

      //약관동의
      allConfirmFlag: "",           //동의체크-전체선택
      confirm_spTerms: "",          //특별약관
      confirm_Terms: "",            //약관동의
      confirm_Info: "",             //개인정보수집이용동의
      confirm_Privacy: "",          //고유식별정보
      confirm_3rd: "",              //개인정보3자제공

      reserConfirm: "N",            //예약컨펌창

      productCode: "",              //상품코드

      cstPrice: 0,                  //상담가격

      personCnt: 0,                 //총인원
      tot_perCount: 0,              //인원총수 <- 상품구매수

      insComment: "",               //예약상담내용

      pdtFlag: "",                  //상품종류
      selectedProcCode: "",         //예약처리상태
      productImage: [],             //상품이미지

      areaFlag: "",

      sRoute: {},                 //상품구분

      optFlag: "",                //옵션선택플래그

      pdtcode: "",

      etcOptName: [],
      etcOptPrice: [],
      vCnt: 0,

      rtnRPflag: "N",               //결제요청여부
      paidFlag: "N",                //결제여부

      handTel: [],                  //매니저연락처
      handTelCnt: 0,                //수신처갯수

      firstPayment: 0,              //부분 또는 전부결제금액
      balance: 0,                   //2차결제액(잔액)
      payStyle: "",                 // 부분(p), 전액(f)결제스타일

      totalPrice: 0,                //권종합산금

      comDC_S: 0,                   //동반할인(스탠다드)
      comDC_P: 0,                   //동반할인(프리미엄)
      tot_comDC: 0,                 //동반자할인 합산액

      uPoint: 0,                    //지급포인트

      //포인트결제
      paidPoint: 0,                 //사용포인트
      payPointFlag: "N",            //포인트사용여부

      pointForPay: 0,               //결제에 사용할 포인트

      payByPointFlag: "N",          //포인트사용 플래그
      pointForPay_tmp: 0,           //포인트 복구용 직전 사용예정 포인트
      rtnRPflag_tmp: [],            //결제 후 포인트와 결제정보

      userPointInfo: 0,             //유저포인트정보
      availPoint: 0,                //유저가용포인트
      pPoint:0,                     //가용포인트 중 지불포인트
      pPointFixFlag: "N",           //포인트사용 고정처리`
      resCodeForVarify: "",         //검증데이타연결용 예약번호

      mainButton: true,             //하단 결제버튼 보이기여부

      userCouponInfo: [],           //유저쿠폰정보
      selCoupon: null,              //선택쿠폰초기값

      canPayCouponFlag: "Y",        //쿠폰결제가능 플래그
      isCoupon: "N",                //이 상품에 적용쿠폰유무(Y/N)
      wpFlag: "N",                  //쿠폰+포인트 병행사용가능 여부(withPoint)
      payCoupon: 0,                 //선택된 쿠폰의 사용금액
      choicedCpCode: "",            //선택된 쿠폰코드
      cpPriceFlag: "",              //쿠폰금액할인방법(A/R)

      payButton: false,             //결제버튼 표시여부

      // 결제파라미터
      pay_rCode: "",
      pay_mFlag: "",
      pay_pFlag: "",
      pay_pgPayment: 0,

      addPdtInfo: [],               //추가상품정보
      addPdtFlag: "N",              //추가상품기본정보
      priceForCoupon: 0,            //쿠폰적용대상금액

      memAddPoint: 2,               //멤버십 전용적립포인트배수(배)
      memDCAmt: 0,                  //멤버십 전용할인금액

      memCouponInfo: [],            //멤버십전용쿠폰정보

      cpSubNo: 0,                   //쿠폰서브넘버

      showCpArea: true,             //선택쿠폰영역표시
      showPtArea: true,             //선택포인트영역표시

      isBlocked: false,             //[임시] 예약차단 처리여부(중복알림 방지) - 정규화 시 제거
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    // 멤버십 등급별 표시명 (N: 엔데이트립 / PS: 멤버십플러스) - 20261023
    memShipName() {
      const memLevel = this.user?.memLevel
      if(memLevel === "PS") return "엔타비 멤버십플러스"
      if(memLevel === "N")  return "엔데이트립 멤버십"
      return ""
    }
  },
  async created() {
    this.reqRsvCode = this.$route.query.resCode;
    this.productId = this.$route.query.prodId;
    this.assoFlag = this.$route.query.assoFlag;

    // [임시] 예약차단 1차: URL 기준 - 정규화 시 제거
    if (this.blockedReservation()) return;

    // 상품정보를 먼저 확보 (쿠폰 적용가능여부 / 지급포인트 계산이 productInfo에 의존) - 20261023
    await this.getProductInfo();

    this.getReserInfo();

    this.getProductPrice();

    this.getHandlerInfo()

    this.getUserPoint()

    this.getUserCouponInfo()      //사용자 쿠폰정보
  },
  mounted() {
    window.scrollTo(0, 0);

    //console.log("user:>>>>", this.user)

    //카카오알림용 인적정보
    if(this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.user.joinFlag === "H" || this.user.joinFlag === "N")
    {
      this.k_name = (!this.user.nickname) ? "" : this.user.nickname;

      let kakaoPhone = ""
      if(this.user.alimCallC != undefined && this.user.alimCallC.charAt(0) === '+')
      {
        kakaoPhone = this.user.alimCallC.replace("+82 ", "0")
      }
      else
      {
        kakaoPhone = this.user.alimCallC
      }
      this.k_tel = (!this.user.alimCallC) ? "" : kakaoPhone.replace(/-/g,""); //-제거
    }
    else
    {
      this.k_name = this.user.name;
      this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g,""); //-제거
    }

    this.resName = this.k_name      //예약자명
    this.resCall = this.k_tel       //예약자연락처
    this.resEmail= this.user.email  //예약자이메일
  },

  watch: {
    myselfFlag: function(newVal) {
      if(newVal === 'Y')
      {
        this.tripName = ""
        this.tripCall = ""
        this.tripEmail = ""
      }
    }
  },

  methods: {
    // ================= [임시] 예약차단 - 정규화 시 제거 =================
    // DB 예약정보 상품코드(productCode)와 URL 상품코드(productId) 중 하나라도 차단 중이면 차단
    // 호출 시점마다 재계산 (페이지를 띄워둔 채 시각이 바뀔 수 있음)
    blockedReservation() {
      const rule = getActiveBlock(this.productCode) || getActiveBlock(this.productId);
      if (!rule) return false;

      // 결제 관련 UI 즉시 닫기
      this.showFlag = false;
      this.payButton = false;
      this.mainButton = false;
      this.paymentDisabled = true;

      // created/getReserInfo/버튼 등에서 연달아 걸려도 알림·이동은 1회만
      if (!this.isBlocked) {
        this.isBlocked = true;
        this.$swal.fire('', rule.message, 'info')
          .then(() => this.$router.replace({ path: '/' }));
      }
      return true;
    },
    // ===================================================================

    //사용자쿠폰정보 (멤버십플러스 C:패키지 / D:선박 월별쿠폰 추가 - 20261023)
    async getUserCouponInfo()
    {
      const today = moment()

      // 멤버십 월별할인쿠폰 타입
      // A: 버스투어(cpCat L) - 엔데이트립/플러스 공통
      // C: 패키지(cpCat T)   - 멤버십플러스 전용
      // D: 선박(cpCat F)     - 멤버십플러스 전용
      const memMonthlyTypes = ['A', 'C', 'D']

      // 상품이 속한 전체 카테고리 = salesRoute + pdtCate(복수, 예: "F,L,T") - 20261023
      // 선박이면서 버스투어/패키지인 상품은 A/C/D 쿠폰이 모두 대상이 됨
      const pdtCates = new Set(
        [this.productInfo.salesRoute, ...String(this.productInfo.pdtCate ?? '').split(',')]
          .map(c => String(c ?? '').trim())
          .filter(c => c)
      )

      // 유저에게 발행된 쿠폰
      let userCouponInfo_tmp = await this.$api("/api/issudUserCpList_ok", {param: [this.user.email]});
      if(!userCouponInfo_tmp || userCouponInfo_tmp.length <= 0) return

      // 일반쿠폰 + B타입(멤버십 전용 신규상품할인)
      let userCouponInfo = userCouponInfo_tmp.filter(obj => obj.cpType === 'B' || !obj.memCpFlag);

      // 사용기간 내 멤버십 월별할인쿠폰(A/C/D)
      let memMonthlyCoupon = userCouponInfo_tmp.filter(obj => {
        if(obj.memCpFlag !== 'Y' || !memMonthlyTypes.includes(obj.cpType)) return false

        let st = moment(obj.memCpStDate, 'YYYY-MM-DD HH:mm:ss')
        let ed = moment(obj.memCpExDate, 'YYYY-MM-DD HH:mm:ss')
        return today.isSameOrAfter(st) && today.isSameOrBefore(ed)
      })

      userCouponInfo = userCouponInfo.concat(memMonthlyCoupon)

      for(let i=0; i<userCouponInfo.length; i++)
      {
        //cpUseCoode: 적용대상(전체상품AL, 전체유저AU, 특정카테고리CA, 특정상품PD, 제휴제외 엔타비NT)
        //cpCat: 카테고리코드, NN:신규상품전용(공동모객제외)
        const cp = userCouponInfo[i]
        let canPay = "N"

        // 일반쿠폰 전체상품할인
        if(!cp.memCpFlag && cp.cpUseCode === "AL")
        {
          canPay = "Y"
        }
        // 일반쿠폰 특정카테고리 할인
        else if(!cp.memCpFlag && cp.cpUseCode === "CA")
        {
          if(cp.cpCat === this.productInfo.salesRoute) canPay = "Y"
        }
        // 일반쿠폰 특정상품 할인
        else if(!cp.memCpFlag && cp.cpUseCode === "PD")
        {
          if(cp.cpPdtCode === this.productInfo.pdtCode) canPay = "Y"
        }
        // 멤버십 월별할인(A:버스투어 / C:패키지 / D:선박) - cpCat에 L/T/F
        else if(cp.memCpFlag === "Y" && memMonthlyTypes.includes(cp.cpType))
        {
          if(pdtCates.has(cp.cpCat))
          {
            canPay = "Y"
            cp.cpExpDate = cp.memCpExDate
          }
        }
        // 멤버십 신규상품할인(B) + 공동모객 판매상품 제외
        else if(cp.memCpFlag === "Y" && cp.cpType === "B")
        {
          const jointFlag = this.productInfo.jointFlag
          if(this.productInfo.newFlag === "Y" && (!jointFlag || jointFlag === "N"))
          {
            canPay = "Y"
          }
        }
        cp.canPay = canPay
      }

      this.userCouponInfo = userCouponInfo;             //쿠폰사용가능정보추가 (canPay)
      this.isCoupon = userCouponInfo.some(obj => obj.canPay === 'Y') ? "Y" : "N"
    },

    async getUserPoint(){
      let userPointInfo = await this.$api("/api/userTotalPoint", {param: [ this.user.email ]})
      //A:가용, U:사용, W:대기
      let availPoint = 0
      if(userPointInfo.length > 0)
      {
        this.userPointInfo = userPointInfo
        //가용포인트 (A-W-S)
        availPoint = this.userPointInfo[0].total_A*1 - this.userPointInfo[0].total_W*1 - this.userPointInfo[0].total_U*1
        this.availPoint = availPoint
      }
    },

    //전체약관동의
    checkAllConfirm()
    {
      if(this.allConfirmFlag === "Y")
      {
        this.confirm_Terms = "Y"
        this.confirm_spTerms = "Y"
        this.confirm_Info = "Y"
        this.confirm_Privacy = "Y"
        this.confirm_3rd = "Y"
      }
      else if(this.allConfirmFlag === "N")
      {
        this.confirm_Terms = "N"
        this.confirm_spTerms = "N"
        this.confirm_Info = "N"
        this.confirm_Privacy = "N"
        this.confirm_3rd = "N"
      }
    },

    async getProductInfo()
    {
      // NEW 상품정보(네이버데이타 공유버전)
      let productInfo = await this.$api("/api/productDetail_new", {param: [this.productId]});

      if(productInfo.length > 0)
      {
        this.productInfo = productInfo[0]
      }
    },

    async getReserInfo()
    {
      //예약정보마스터 (상품정보는 created에서 선로딩 - 중복호출 제거 20261023)
      let reserveInfo = await this.$api("/api/resConsultDetail_new", {param: [this.reqRsvCode]});

      if(reserveInfo.length > 0)
      {
        this.reserveInfo = reserveInfo[0];
        this.tot_perCount = reserveInfo[0].totalCount                                              //New가격에서는 상품구매수 = 인원수
        this.productCode = reserveInfo[0].reqPdtCode;
        this.reserveInfo.conEmail = (!reserveInfo[0].conEmail) ? reserveInfo[0].reqEmail : reserveInfo[0].conEmail;   //예약자 이메일 우선적용
        //출발예정일-리턴예정일
        this.reserveInfo.reqDptDate = this.getDateFormat(this.reserveInfo.reqDptDate);
        this.reserveInfo.reqRtnDate = this.getDateFormat(this.reserveInfo.reqRtnDate);
        this.reserveInfo.reqDate = this.getDateFormat(this.reserveInfo.reqDate);                   //insDate 예약일
        this.priceForCoupon = this.reserveInfo.priceForCoupon                                      //쿠폰적용대상금액
        this.memDCAmt = this.reserveInfo.memDCAmt                                                  //멤버십 전용할인금액
      }

      // [임시] 예약차단 2차: DB 예약정보의 상품코드 기준 (URL prodId 조작 대비) - 정규화 시 제거
      if (this.blockedReservation()) return;

      // 선택형 옵션정보
      this.getSelOptInfo();
      // 직접형 옵션정보
      this.getDirOptInfo();

      // 추가상품 정보
      this.getAddPdtInfo();

      //지급포인트추출
      this.getPoint()
    },

    async getAddPdtInfo() {
      let addPdtInfo = await this.$api("/api/addPdtInfo", {param: [this.reqRsvCode]});

      if(addPdtInfo.length > 0)
      {
        this.addPdtFlag = "Y"           //추가상품여부
        this.addPdtInfo = addPdtInfo;
        this.getTotalPrice();
      }
      else
      {
        // 결제금액계산
        this.getTotalPrice();
      }
    },

    async getSelOptInfo() {
      let selOptInfo = await this.$api("/api/selOptInfo", {param: [this.reqRsvCode]});

      if(selOptInfo.length > 0)
      {
        this.selOptFlag = "Y"           //선택옵션유무
        this.selOptInfo = selOptInfo;
        this.getTotalPrice();
      }
      else
      {
        // 결제금액계산
        this.getTotalPrice();
      }
    },

    async getDirOptInfo() {
      let dirOptInfo = await this.$api("/api/dirOptInfo", {param: [this.reqRsvCode]});

      if(dirOptInfo.length > 0)
      {
        this.dirOptFlag = "Y"           //직접옵션유무
        this.dirOptInfo = dirOptInfo;
      }
    },

    //결제총액추출
    getTotalPrice() {
      let totalPrice = 0
      let total_AddPdtPrice = 0

      // 선택옵션의 총액
      if(this.selOptInfo.length > 0) {
        totalPrice = this.selOptInfo.reduce((sum, item) => sum + (item.optPrice * (item.qty_opt ?? 0)), 0);
      }

      // 추가상품의 총액
      if(this.addPdtInfo.length > 0) {
        total_AddPdtPrice = this.addPdtInfo.reduce((sum, item) => sum + (item.addPrice * (item.addQty ?? 0)), 0);
      }      

      this.pdtTotalPrice = totalPrice + total_AddPdtPrice

      // 멤버십인 경우 기본할인 적용
      if(this.memDCAmt > 0 && (this.reserveInfo.memShip != null && this.reserveInfo.memShip != "" && this.reserveInfo.memShip != undefined)) 
      {
        this.pdtTotalPrice = this.pdtTotalPrice - this.memDCAmt
      }
    },

    //상품가격
    async getProductPrice() {
      let useFlag = "Y";
      let productPrice = await this.$api("/api/productPrice_new", {param: [this.productId, useFlag]});

      if(productPrice.length > 0)
      {
        this.productPrice = productPrice;
        this.startingPrice = productPrice[0].pdtPrice;                   // 상품최초세팅가격
        this.dcPrice       = productPrice[0].dcPrice;                    // 할인수치
        this.dcMethod      = productPrice[0].dcMethod;                   // 할인법(P/A)

        // 기준가격
        if(productPrice[0].dcMethod === "P")
        {
          this.basicPrice = this.startingPrice - (this.startingPrice * (this.dcPrice / 100)); // 할인율 적용
        }
        else if(productPrice[0].dcMethod === "A")
        {
          this.basicPrice = this.startingPrice - this.dcPrice; // 할인액 적용
        }
      }
    },

    //예약완료(reserComplete(this.reqRsvCode, 'p1'))
    async reserComplete(rCode, payFlag){
      if (this.blockedReservation()) return false;     // [임시] 예약차단 - 정규화 시 제거

      this.paymentDisabled = true       //결제선택 이후, 선택내용 변경불가화

      if(this.reserveInfo.totalCount < 1)
      {
        this.$swal.fire("","구매상품 수를 확인해주세요.","warning")
        return false
      }

      if(!this.resCall)
      {
        this.$refs.resCall.focus()
        this.$swal.fire("","예약자의 연락처를 입력하세요.","warning")
        return false
      }
      else
      {
        let checkResult = this.checkMobile(this.resCall)      //mobile number 유효체크
        if(!checkResult)
        {
          this.$refs.resCall.select()
          this.$swal.fire("","유효한 전화번호가 아닙니다.","warning")
          return false
        }
      }

      if(!this.resEmail)
      {
        this.$refs.resEmail.focus()
        this.$swal.fire("","예약자의 이메일(회원아이디)을 입력하세요.","warning")
        return false
      }

      if(this.myselfFlag === 'N')
      {
        if(!this.tripName)
        {
          this.$refs.tripName.focus()
          this.$swal.fire("","여행객명을 입력하세요.","warning")
          return false
        }

        if(!this.tripCall)
        {
          this.$refs.tripCall.focus()
          this.$swal.fire("","여행객의 연락처를 입력하세요.","warning")
          return false
        }
        else
        {
          let checkResult = this.checkMobile(this.tripCall)      //mobile number 유효체크
          if(!checkResult)
          {
            this.$refs.tripCall.select()
            this.$swal.fire("","유효한 전화번호가 아닙니다.","warning")
            return false
          }
        }
      }

      if(this.confirm_spTerms != "Y")
      {
        this.$refs.confirm_spTerms.focus()
        this.$swal.fire("","특별약관에 동의를 해주세요","warning")
        return false
      }

      if(this.confirm_Terms != "Y")
      {
        this.$refs.confirm_Terms.focus()
        this.$swal.fire("","약관에 동의를 해주세요","warning")
        return false
      }

      if(this.confirm_Info != "Y")
      {
        this.$refs.confirm_Info.focus()
        this.$swal.fire("","개인정보수집이용에 동의를 해주세요","warning")
        return false
      }

      if(this.confirm_Privacy != "Y")
      {
        this.$refs.confirm_Privacy.focus()
        this.$swal.fire("","고유식별정보수집이용에 동의를 해주세요","warning")
        return false
      }

      if(this.confirm_3rd != "Y")
      {
        this.$refs.confirm_3rd.focus()
        this.$swal.fire("","개인정보3자제공에 동의를 해주세요","warning")
        return false
      }

      this.mainButton = false

      let completeFlag = "N"            //결제가 완료될 때까지 N(변경된 결제프로세스 반영)

      //1차결제액 설정(전액결제진행)
      let totalPayAmount = this.pdtTotalPrice*1 - this.payCoupon*1 - this.pPoint*1      //결제할 총액(멤버십의 경우 기본할인 반영된 금액) - 쿠폰 또는 포인트 사용액(할인총액 1회처리)
      let firstPayment = 0  //1차결제액
      let balance = 0       //잔액(2차결제액)
      let pFlag = ""

      if(payFlag === "fu")
      {
        firstPayment = this.getTruncateToWon(totalPayAmount)
      }
      else if(payFlag === "p1")
      {
        if(this.productInfo.paymentMethod === "P")
        {
          firstPayment = this.getTruncateToWon(totalPayAmount * (this.productInfo.firstPayment/100))
        }
        else if(this.productInfo.paymentMethod === "A")
        {
          firstPayment = this.getTruncateToWon(this.productInfo.firstPayment * 1)
        }
      }
      // p1 or fu
      pFlag = payFlag
      this.payStyle = payFlag

      balance = totalPayAmount - firstPayment        //잔액계산

      this.firstPayment = firstPayment
      this.balance = balance

      //// new 예약완료처리 (20250805) + 추가상품반영 (20250901)
      let upd_completeReserInfo = await this.$api("/api/proc_updCompleteReserve_new_new", {param:[
        rCode,
        this.askQuestion, completeFlag, this.resName, this.resCall, this.resEmail,
        totalPayAmount, this.myselfFlag, this.tripName, this.tripCall, this.tripEmail,
        this.confirm_spTerms, this.confirm_Terms, this.confirm_Info, this.confirm_Privacy, this.confirm_3rd,
        this.productInfo.userPointMethod,this.uPoint,
        pFlag,
        this.dirOptFlag, this.selOptFlag, firstPayment, balance, this.pPoint, this.payCoupon,
        this.startingPrice, this.dcPrice, this.dcMethod, this.basicPrice, this.addPdtFlag
      ]})

      if(upd_completeReserInfo.affectedRows <0)
      {
        this.$swal.fire('','<b class="text-danger">죄송합니다</b><br>처리 중 문제가 발생했습니다.('+ upd_completeReserInfo.error.sqlMessage +')', 'warning')
        return false;      
      }
      else 
      {
        this.payButton      = true;     //결제버튼 표시
      }
    },

    //지급포인트 (멤버십플러스 PS도 배수적용 - 20261023)
    getPoint(){
      // 멤버십(엔데이트립 N / 멤버십플러스 PS)은 포인트 배수적용
      const memLevel = this.user.memLevel
      if(memLevel === "N" || memLevel === "PS")
      {
        this.uPoint = (this.productInfo.userPoint*1) * (this.memAddPoint*1)
      }
      else
      {
        this.uPoint = this.productInfo.userPoint
      }
    },

    ///////////공통함수
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    getTruncateToWon(value){
      return this.$truncateToWon(value)
    },

    goToList() {
      this.$router.push({path: '/'});
    },

    checkMobile(val){
      const koreanMobileRegex = /^01[0]\d{3,4}\d{4}$/;
      return koreanMobileRegex.test(val);
    },

    checkEmail(val){
      const emailRegex = /^(?!.*\.{2})[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      return emailRegex.test(val);
    },

    /************************* 위젯초기화 + 즉시결제로 연결*******************************/

    //mFlag: 회원(null 또는 공란)/비회원(N), pFlag: p1(부분결제)/fu(전액결제) / pgPayment: 결제금액(차감금액 처리완료)
    async requestPayment(rCode, mFlag, pFlag, pgPayment) {
      if (this.blockedReservation()) return false;     // [임시] 예약차단 - 정규화 시 제거

      this.showFlag = true          //결제위젯열기

      let resCode = (pFlag === "p1") ? rCode + "-1" : rCode
      this.resCodeForVarify = resCode       //검증데이타용 예번저장

      let payPointAmt  = this.pPoint
      let payCouponAmt = this.payCoupon

      // 신멤버십 쿠폰OK
      let veriSign = "N"
      let insVeriData = await this.$api("/api/proc_setVeriData_1", {param: [
        resCode, pgPayment, veriSign, pFlag, payPointAmt, payCouponAmt
      ]});

      if(insVeriData.affectedRows < 0)
      {
        this.$swal.fire("","검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning")
        return false;
      }

      //결제요청정보저장(시스템 내부처리용)
      let insReqPay = await this.insReqPay(resCode, "RP", pgPayment, this.resEmail, pFlag, rCode, payPointAmt, payCouponAmt)
      if(!insReqPay)
      {
        this.$swal.fire("","결제요청정보가 생성되지 않았습니다. 재시도해주세요", "warning")
        return false;
      }

      // 쿠폰 / 포인트 / 일반결제 상호배타 분기 (동시선택 시 pgPay 중복호출 방지)
      if(this.payCoupon > 0)
      {
        await this.handleCouponPayment(rCode, mFlag, pFlag, pgPayment, resCode)
      }
      else if(this.pPoint > 0 && this.pPointFixFlag === "Y")
      {
        await this.handlePointPayment(rCode, mFlag, pFlag, pgPayment, resCode)
      }
      else
      {
        this.pgPay(resCode, mFlag, pFlag, pgPayment)  //결제진행
      }
    },

    // 쿠폰 결제 처리 (전액쿠폰 / 부분결제+쿠폰)
    async handleCouponPayment(rCode, mFlag, pFlag, pgPayment, resCode) {
      if(pgPayment == 0)
      {
        this.paymentWidget = false      //토스페이초기화해제
        this.showFlag = false
        this.mainButton = false

        const result = await this.$swal.fire({
          icon: "question",
          html: "쿠폰으로 전액결제를 하시겠습니까?",
          showCancelButton: true,
          confirmButtonText: '네, 그렇습니다',
          cancelButtonText: '아니요',
        })

        if(result.isConfirmed)
        {
          //전액을 쿠폰으로 결제
          this.payByPointOnly(rCode, mFlag, pFlag, pgPayment, 'C')
        }
        else
        {
          location.reload(true)
        }
        return
      }

      let useFlag = "A"   //쿠폰사용상태(A:사용대기)
      let payByCoupon = await this.$api("/api/payByCoupon", {param: [
        useFlag, this.user.email, this.reqRsvCode,  this.user.email, this.choicedCpCode, this.cpSubNo
      ]});
      // 0건 반영 = 대상 쿠폰 미존재 → 실패처리 (20261023)
      if(!payByCoupon || payByCoupon.error || payByCoupon.affectedRows < 1)
      {
        this.$swal.fire('', '쿠폰 결제처리 중 오류가 발생하였습니다(코드: payByCoupon)<br>쿠폰 복구문의: 1660-4602', 'error');
        return false;
      }
      //결제포인트가 반영되도록 검증데이타 업데이트 + 초기화 재진행
      else
      {
        let updVerifyData = await this.$api("/api/updVerifyData_cp", {param:
          [ pgPayment, this.payCoupon, this.choicedCpCode, this.cpSubNo, this.resCodeForVarify ]
        });
        if(updVerifyData.affectedRows < 0)
        {
          this.$swal.fire("","검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning")
          return false;
        }
        else
        {
          //부분결제 + 쿠폰결제정보저장(시스템 내부처리용 tb_reqPay)
          let reqPayStatus = "PY"
          let paidId = this.user.email
          let actualPayAmount = pgPayment

          let updReqPayForCoupon_p1 = await this.$api("/api/updReqPayForCoupon_p1", {param:
            [ reqPayStatus, paidId, actualPayAmount, rCode, actualPayAmount, this.payCoupon,  this.resCodeForVarify ]
          });

          if(updReqPayForCoupon_p1.affectedRows<0)
          {
            this.$swal.fire("", "죄송합니다. 결제정보 처리 중 오류가 발생했습니다. 다시 진행을 해주십시오.", "warning")
            return false;
          }
          else
          {
            this.pgPay(resCode, mFlag, pFlag, pgPayment)  //결제진행
          }              
        }
      }
    },

    // 포인트 결제 처리 (전액포인트 / 부분결제+포인트)
    async handlePointPayment(rCode, mFlag, pFlag, pgPayment, resCode) {
      if(pgPayment == 0)                // PG청구금액0
      {
        this.paymentWidget = false      //토스페이초기화해제
        this.showFlag = false
        this.mainButton = false

        const result = await this.$swal.fire({
          icon: "question",
          html: "포인트로 전액결제를 하시겠습니다?",
          showCancelButton: true,
          confirmButtonText: '네, 그렇습니다',
          cancelButtonText: '아니요',
        })

        if(result.isConfirmed)
        {
          //전액을 포인트로 결제
          this.payByPointOnly(rCode, mFlag, pFlag, pgPayment, 'P')
        }
        else
        {
          location.reload(true)
        }
        return
      }

      let payByPoint = await this.$api("/api/payByPoint", {param: [
        this.user.email, this.pPoint, 'S', rCode, '사용대기'
      ]});
      if(payByPoint.affectedRows < 0 || payByPoint.affectedRows == undefined)
      {
        this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다(코드: payByPoint)<br>포인트 복구문의: 1660-4602', 'error');
        return false;
      }
      //결제포인트가 반영되도록 검증데이타 업데이트 + 초기화 재진행
      else
      {
        let updVerifyData = await this.$api("/api/updVerifyData", {param:
          [ pgPayment, this.pPoint, this.resCodeForVarify ]
        });
        if(updVerifyData.affectedRows < 0)
        {
          this.$swal.fire("","검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning")
          return false;
        }
        else
        {
          //부분결제 + 포인트결제정보저장(시스템 내부처리용 tb_reqPay)
          let reqPayStatus = "PY"
          let paidId = this.user.email
          let actualPayAmount = pgPayment
          let updReqPayForPoint = await this.$api("/api/updReqPayForPoint_p1", {param:
            [ reqPayStatus, paidId, actualPayAmount, rCode, actualPayAmount, this.pPoint,  this.resCodeForVarify ]
          });

          if(updReqPayForPoint.affectedRows<0)
          {
            this.$swal.fire("", "죄송합니다. 결제정보 처리 중 오류가 발생했습니다. 다시 진행을 해주십시오.", "warning")
            return false;
          }
          else
          {
            this.pgPay(resCode, mFlag, pFlag, pgPayment)  //결제진행
          }
        }
      }
    },

    // PG결제처리
    async pgPay(rCode, mFlag, pFlag, pgPayment)     //mFlag: N비회원, pFlag: p1 or fu
    {
      this.pay_rCode = rCode
      this.pay_mFlag = mFlag
      this.pay_pFlag = pFlag
      this.pay_pgPayment = pgPayment
      
      // ------  결제위젯 초기화 ------
      this.paymentWidget = await loadPaymentWidget(this.clientKey, ANONYMOUS);

      // ------  결제 UI 렌더링 ------
      this.paymentMethodWidget = this.paymentWidget.renderPaymentMethods("#payment-method", { value: pgPayment }, { variantKey: "DEFAULT" });
    },

    //결제처리
    async doPay() {
      if (this.blockedReservation()) return false;     // [임시] 예약차단 (PG결제창 호출 직전 최종방어) - 정규화 시 제거

      try
      {
        if (this.paymentWidget)
        {
          // 비회원결제
          if(this.pay_mFlag === 'N')
          {
            await this.paymentWidget.requestPayment({
              orderId: this.pay_rCode,
              orderName: this.productInfo.pdtNameKor,
              // successUrl: `${process.env.VUE_APP_SITE_URL}/success_pg`,
              // failUrl: `${process.env.VUE_APP_SITE_URL}/fail_pg`,
              // successUrl: 'http://localhost/success_pg',
              // failUrl: 'http://localhost/fail_pg',
              successUrl: 'https://ntabi.co.kr/success_pg',
              failUrl: 'https://ntabi.co.kr/fail_pg',
              customerEmail: this.resEmail,
              customerName: this.resName,
              taxFreeAmount: this.pay_pgPayment
            });
          }
          // 회원결제
          else
          {
            await this.paymentWidget.requestPayment({
              orderId: this.pay_rCode,
              orderName: this.productInfo.pdtNameKor,
              // successUrl: `${process.env.VUE_APP_SITE_URL}/success_pg`,
              // failUrl: `${process.env.VUE_APP_SITE_URL}/fail_pg`,
              // successUrl: 'http://localhost/success_pg',
              // failUrl: 'http://localhost/fail_pg',
              successUrl: 'https://ntabi.co.kr/success_pg',
              failUrl: 'https://ntabi.co.kr/fail_pg',
              customerEmail: this.resEmail,
              customerName: this.resName,
              taxFreeAmount: this.pay_pgPayment
            });
          }
        }
      }
      catch (error)
      {
        console.error(error);
      }
    },

    // 결제선택취소(쿠폰, 포인트가 있다면 초기화)
    cxlPayment() {
      this.mainButton = true              //메인, 결제하기 버튼재표시
      this.payCoupon = 0
      this.pPoint = 0
      this.selCoupon = null               //쿠폰 비선택화

      this.payButton = false              //결제선택버튼 비활성화
      this.pPointFixFlag = "N"            //포인트결제버튼 초기화(활성화)

      this.showCpArea = true
      this.showPtArea = true

      this.paymentDisabled = false        //쿠폰. 포인트 변경허용

      this.showFlag = false               //결제위젯닫기
    },

    //쿠폰선택 처리
    choiceCoupon(cpCode, wpFlag, cpPrice_tmp, cpPriceFlag, cpSubNo){   //cpPriceFlag: A/R
      if(this.paymentDisabled) 
      {
        this.$swal.fire("","결제선택 이후 변경할 수 없습니다.<br>결제취소 후, 다시 진행해주세요", "warning")
        return false;
      }

      //선택된 쿠폰이 포인트병행 가능여부 체크하여 포인트표시 처리
      //포인트와 쿠폰의 병행결제기능은 차후 개발
      this.wpFlag = wpFlag                 //포인트와 병용가능여부
      this.choicedCpCode = cpCode          //선택된 쿠폰코드
      this.cpPriceFlag = cpPriceFlag       //쿠폰할인방법(A:amt / R:rate)
      this.cpSubNo = cpSubNo               //쿠폰서브넘버

      let cpPrice = 0                      //쿠폰할인가격
      let payCoupon = 0                    //쿠폰의 결제가격

      if(cpPriceFlag === "A")
      {
        cpPrice = cpPrice_tmp
      }
      else
      {
        if(this.payStyle === "p1")       //부분결제
        {
          cpPrice = (this.priceForCoupon) * (cpPrice_tmp/100)
        }
        else                            //전액결제
        {
          cpPrice = (this.priceForCoupon) * (cpPrice_tmp/100)
        }
      }

      if(wpFlag === "Y")
      {
        this.pPoint = 0
        this.pPointFixFlag = "N"       //포인트사용고정해제
        this.showPtArea = true
      }
      else if(wpFlag === "N")
      {
        this.pPoint = 0
        this.pPointFixFlag = "Y"
        this.showPtArea = false
      }

      this.selCoupon = (cpCode == "N") ? null : cpCode

      if(cpPrice > this.priceForCoupon)
      {
        this.$swal.fire("","선택된 쿠폰금액이 할인대상금액을 초과합니다<br>쿠폰결제 시, 잔액은 반환되지 않습니다", "warning")
        payCoupon = this.priceForCoupon
      }
      else
      {
        payCoupon = cpPrice*1
      }

      this.payCoupon = payCoupon*1        //선택쿠폰의 실제결제액(쿠폰표시액과 사용액이 다를 경우가 있으므로 분리)
    },

    //포인트 결제액 체크
    payByAvailPoint(pPt){
      if(pPt < 0)
      {
        this.$refs.pPoint.select();
        this.$swal.fire("","사용 포인트는 0이상이어야 합니다.", "warning")
        return false
      }
      else if(pPt > this.availPoint)
      {
        this.$refs.pPoint.select();
        this.$swal.fire("","사용포인트는 가용포인트보다 클 수 없습니다.", "warning")
        return false
      }
      else
      {
        if(pPt >= this.pdtTotalPrice) 
        {
          this.$swal.fire("","사용포인트가 결제금액을 초과하여 조정합니다.", "info")
          pPt = this.pdtTotalPrice
        }
      }
      
      this.pPoint = pPt           //최종 사용할 포인트
      this.pPointFixFlag = "Y"
      this.showCpArea = false
    },

    //포인트 사용 초기화
    makeDefpPoint(){
      this.pPointFixFlag = "N"
      this.pPoint = 0
      this.showCpArea = true
    },

    //전액포인트처리(쿠폰결제도 포함 20250320 + 멤버십전용쿠폰포함 20260107)
    async payByPointOnly(rCode, mFlag, pFlag, pgPayment, method){
      //결제액을 포인트로 결제
      if(method === "P")
      {
        let payByPoint = await this.$api("/api/payByPoint", {param: [
          this.user.email, this.pPoint, 'S', rCode, '사용대기'
        ]});
        if(payByPoint.affectedRows < 0 || payByPoint.affectedRows == undefined)
        {
          this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다<br>포인트 복구문의: 1660-4602', 'error');
          return false;
        }
        //결제포인트가 반영되도록 검증데이타 업데이트
        else
        {
          let updVerifyData = []
          if(pFlag == "p1")
          {
            updVerifyData = await this.$api("/api/updVerifyData", {param:
              [ pgPayment, this.pPoint, this.resCodeForVarify ]
            });
          }
          else
          {
            updVerifyData = await this.$api("/api/updVerifyData", {param:
              [ pgPayment, this.pPoint, rCode ]
            });
          }
          if(updVerifyData.affectedRows < 0)
          {
            this.$swal.fire("","검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning")
            return false;
          }
          else
          {
            //결제요청정보저장(시스템 내부처리용)
            let updReqPayForPoint = []
            let reqPayStatus = "PY"
            let paidId = this.user.email
            let actualPayAmount = 0
            if(pFlag == "p1")
            {
              updReqPayForPoint = await this.$api("/api/updReqPayForPoint", {param:
                [ reqPayStatus, paidId, pgPayment, this.pPoint, actualPayAmount, this.resCodeForVarify ]
              });
            }
            else
            {
              updReqPayForPoint = await this.$api("/api/updReqPayForPoint", {param:
                [ reqPayStatus, paidId, pgPayment, this.pPoint, actualPayAmount, rCode ]
              });
            }
            if(updReqPayForPoint.affectedRows<0)
            {
              this.$swal.fire("", "죄송합니다. 결제정보 처리 중 오류가 발생했습니다. 다시 진행을 해주십시오.", "warning")
              return false;
            }
            else
            {
              //예약정보 완료처리
              let updResveStat = []
              let balace = 0
              let firstPayment = 0
              let completeFlag = "Y"
              let partFlag = ""

              if(pFlag == "p1")                //일부포인트결제
              {
                balace = (this.firstPayment) - this.pPoint
                partFlag = "1"
              }
              else if(pFlag == "p2")
              {
                partFlag = "2"
              }
              else
              {
                partFlag = "fu"
              }

              updResveStat = await this.$api("/api/updResveStat_pointOnly", {param:
                ['PY', this.user.email, firstPayment, balace, partFlag, completeFlag, this.pPoint, rCode]
              });

              if(updResveStat.affectedRows < 0)
              {
                this.$swal.fire("","예약처리 중 오류가 발생했습니다. 고객센터(1660-4602)로 연락을 주시면 감사하겠습니다.", "warning")
                return false;
              }
              else
              {
                let upd_UsePoint = await this.$api("/api/upd_UsePoint", {param: [ this.user.email, rCode ]});
                if(upd_UsePoint.affectedRows < 0)
                {
                  this.$swal.fire("","죄송합니다. 포인트 처리에 문제가 발생했습니다(예약번호:"+ rCode +").<br>포인트문의: 1660-4602","warning")
                  return false;
                }
                else
                {
                  // 구매가 완료되면 재고를 차감한다 + 추가상품반영(20250901)
                  await this.update_selOptQty(this.reqRsvCode)

                  this.sendKakaoByPay("PY", rCode)
                }
              }
            }
          }
        }
      }

      //결제액을 쿠폰으로 결제
      else if(method === "C")
      {
        //쿠폰 임시사용처리(A)
        //파라미터 순서를 handleCouponPayment / 확정(Y)처리와 동일하게 맞춤 - 20261023 (sql.js payByCoupon 정의 확인 필요)
        let useFlag = "A"
        let payByCoupon = await this.$api("/api/payByCoupon", {param: [
          useFlag, this.user.email, this.reqRsvCode, this.user.email, this.choicedCpCode, this.cpSubNo
        ]});

        // 0건 반영 = 대상 쿠폰 미존재 → 실패처리 (20261023)
        if(!payByCoupon || payByCoupon.error || payByCoupon.affectedRows < 1)
        {
          this.$swal.fire('', '쿠폰 결제처리 중 오류가 발생하였습니다<br>쿠폰 복구문의: 1660-4602', 'error');
          return false;
        }
        //쿠폰결제가 반영되도록 검증데이타 업데이트
        else
        {
          let resCode = ""
          if(pFlag == "p1")
          {
            resCode = this.resCodeForVarify
          }
          else
          {
            resCode = rCode
          }

          let updVerifyData = await this.$api("/api/updVerifyData_cp", {param:
              [ pgPayment, this.payCoupon, this.choicedCpCode, this.cpSubNo, resCode ]
            });
          if(updVerifyData.affectedRows < 0)
          {
            this.$swal.fire("","검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning")
            return false;
          }
          else
          {
            //결제요청정보저장(시스템 내부처리용)
            let reqPayStatus = "PY"
            let paidId = this.user.email
            let actualPayAmount = 0
            let resCode = ""
            if(pFlag == "p1")
            {
              resCode = this.resCodeForVarify
            }
            else
            {
              resCode = rCode
            }

            let updReqPayForCoupon = await this.$api("/api/updReqPayForCoupon", {param:
                [ reqPayStatus, paidId, pgPayment, this.payCoupon, actualPayAmount, resCode ]
              });
            if(updReqPayForCoupon.affectedRows<0)
            {
              this.$swal.fire("", "죄송합니다. 결제정보 처리 중 오류가 발생했습니다. 다시 진행을 해주십시오.", "warning")
              return false;
            }
            else
            {
              //예약정보 완료처리
              let updResveStat = []
              let balace = 0
              let firstPayment = 0
              let completeFlag = "Y"
              let partFlag = ""

              if(pFlag == "p1")                //일부 쿠폰결제
              {
                balace = this.firstPayment - this.payCoupon
                partFlag = "1"
              }
              else if(pFlag == "p2")
              {
                partFlag = "2"
              }
              else
              {
                partFlag = "fu"
              }

              updResveStat = await this.$api("/api/updResveStat_couponOnly", {param:
                ['PY', this.user.email, firstPayment, balace, partFlag, completeFlag, this.payCoupon, rCode]
              });

              if(updResveStat.affectedRows < 0)
              {
                this.$swal.fire("","예약처리 중 오류가 발생했습니다. 고객센터(1660-4602)로 연락을 주시면 감사하겠습니다.", "warning")
                return false;
              }
              else
              {
                // 구매가 완료되면 재고를 차감한다 + 추가상품반영(20250901)
                await this.update_selOptQty(this.reqRsvCode)
                
                //쿠폰사용 확정처리
                let cpUseFlag = "Y"
                let payByCoupon = await this.$api("/api/payByCoupon", {param:
                  [ cpUseFlag, this.user.email, this.reqRsvCode, this.user.email, this.choicedCpCode, this.cpSubNo ]});
                // 0건 반영 = 대상 쿠폰 미존재 → 실패처리 (20261023)
                if(!payByCoupon || payByCoupon.error || payByCoupon.affectedRows < 1)
                {
                  this.$swal.fire("","죄송합니다. 쿠폰사용처리에 문제가 발생했습니다(예약번호:"+ rCode +").<br>쿠폰문의: 1660-4602","warning")
                  return false;
                }
                else
                {
                  // 쿠폰사용카운트(통계용)
                  await this.$api("/api/updateUsedCpQtyCnt", {param: [ this.choicedCpCode ]});
                  this.sendKakaoByPay("PY", rCode)
                }
              }
            }
          }
        }
      }

    },

    //구매 후 재고수량 차감
    async update_selOptQty(oId) {
      let updFlag = 'M'       //M-minus, P-plus
      let upd_selOptQty = await this.$api("/api/proc_updOptSel_qty", {param: [oId, updFlag]})
      if(upd_selOptQty.affectedRows <1)
      {
        this.$swal.fire('','<b class="text-danger">죄송합니다</b><br>처리 중 문제가 발생했습니다.('+ upd_selOptQty.error.sqlMessage +')', 'warning')
        return false;
      }
      
      // 추가상품 구매가 있다면, 추가상품 재고도 차감
      if(this.addPdtFlag == "Y") 
      {
        let upd_addPdtQty = await this.$api("/api/proc_updAddPdt_qty", {param: [oId, updFlag]})
        if(upd_addPdtQty.affectedRows <1)
        {
          this.$swal.fire('','<b class="text-danger">죄송합니다</b><br>처리 중 문제가 발생했습니다.('+ upd_addPdtQty.error.sqlMessage +')', 'warning')
          return false;
        }
      }
    },

    //PG를 통하지 않는 결제결과 카톡발송
    async sendKakaoByPay(param, val, orderId) //PY or WP, SP/NB or notSP
    {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        orderId, param, this.user.email
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: this.resCall})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows > 0)
      {
        let kakaoAlimData = {}
        let promises = []         //promise들의 배열

        let resPayAmount = 0
        if(this.payStyle === "p2")
        {
          resPayAmount = this.payDetailInfo.balance
        }
        else
        {
          resPayAmount = this.pPoint
        }
        let j = 0
        while(j < this.handTelCnt)
        {
          kakaoAlimData =
          {
            //카카오 알림톡 발송(결제완료)
            clientName: this.resName,
            resName: this.productInfo.pdtNameKor,
            resPaxName: this.resName,
            resPaxCnt: this.tot_perCount,
            dptDate: this.reserveInfo.reqDptDate,
            resPhone: this.resCall,
            resCode: this.reqRsvCode,
            resPayAmount: this.getCurrencyFormat(resPayAmount),
            resManager: this.productInfo.manName,
            alimFlag: param,                                                  //알림유형(결제완료)
            alimCall: this.handTel[j].aimCall,                                //알림톡발송대상
            pdtCode: this.productInfo.pdtCode                                 //비회원예약 결제처리용 상품코드
          };

          let promise = this.$api("api/kakaoAlimSend2", {
            param: [{ kakaoAlimData: kakaoAlimData}]
          })

          promises.push(promise)
          j++
        }

        //반복문 이후 처리
        Promise.all(promises).then(() => {
          this.$swal.fire('', '결제완료 알림톡이 발송되었습니다', 'success').then(() => {
            this.$router.push({ path: "/" });
          })
        }).catch((error) => {
          console.log("Error calling api: ", error)
        })
      }
    },

    //결제요청 정보처리
    async insReqPay(rCode, stat, payAmt, resEmail, pFlag, rCode_org, pPoint, couponAmt)    //pFlag: p1,p2(1차,2차결제) / fu,NULL(전액결제)
    {
      let rCodeOrg = ""
      if(pFlag === "p1")
      {
        rCodeOrg = rCode_org
      }
      else
      {
        rCodeOrg = ""
      }

      let insReqPayInfo = await this.$api("/api/proc_insReqPayInfo_2",{param: [
          rCode, stat, payAmt, 'N', resEmail, pFlag, this.firstPayment*1, rCodeOrg, pPoint, couponAmt
        ]});

      if(insReqPayInfo.affectedRows < 0)
      {
        this.$swal.fire('','처리 중 오류발생(insReqPayInfo)<br>관리자에게 문의하세요', 'error')
        return false;
      }
      else
      {
        return true;
      }
    },

    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
    },

    /** 카카오알림 발송(예약접수BO) */
    //param: BO/BO_non
    async sendKakao(param, resCode)
    {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        resCode, param, this.resCall
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: this.resCall})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows >= 0)
      {
        let kakaoAlimData = {}

        if(param == "BO")
        {
          //카카오 알림톡 발송(비회원 예약접수)
          if(this.reserveInfo.resMFlag === "N")
          {
            let i = 0
            while(i < this.handTelCnt)
            {
              kakaoAlimData =
              {
                clientName: this.resName,                           //수신자명
                clientCall: this.handTel[i].aimCall,                //수신자전번
                resName: this.productInfo.pdtNameKor,               //예약상품
                resPaxName: this.resName,                           //예약자명
                resPaxCnt: this.tot_perCount,                       //여행인원
                dptDate: this.reserveInfo.reqDptDate,               //여행일자(출발일)
                resPhone: this.resCall,                             //대표연락처
                resCode: resCode,                                   //예약번호
                alimFlag: "nonBO",                                  //알림유형(예약접수)
              };

              //예약접수안내 API호출
              this.$api("api/kakaoAlimSend2", {
                param: [
                  { kakaoAlimData: kakaoAlimData},
                ]
              }).then((res) => {console.log(res)});
              i++
            }
          }

          //카카오 알림톡 발송(회원 예약접수)
          else
          {
            let j = 0
            while(j < this.handTelCnt)
            {
              kakaoAlimData =
              {
                clientName: this.k_name,                          //수신자명
                clientCall: this.handTel[j].aimCall,              //수신자전번
                resName: this.productInfo.pdtNameKor,             //예약상품
                resPaxName: this.resName,                         //예약자명
                resPaxCnt: this.tot_perCount,                     //여행인원
                dptDate: this.reserveInfo.reqDptDate,             //여행일자(출발일)
                resPhone: this.resCall,                           //대표연락처
                resCode: resCode,                                 //예약번호
                alimFlag: param,                                  //알림유형(예약접수)
              };

              //예약접수안내 API호출
              this.$api("api/kakaoAlimSend2", {
                param: [
                  { kakaoAlimData: kakaoAlimData},
                ]
              }).then((res) => {console.log(res)});
              j++
            }
          }
        }
      }
    },

    async getPayDetailInfo(orderId)
    {
      let resNo = orderId
      let payDetailInfo = await this.$api("/api/payDetailInfo", {param: [resNo]});
      if(payDetailInfo.length > 0)
      {
        this.payDetailInfo = payDetailInfo[0];
        //결제완료 카톡안내
        this.sendKakao("PY", resNo);
      }
    },

  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;600;700&display=swap');
 
 /* ================================================
   # CSS 변수 — 원본 클래스명 기준
 ================================================ */
 #reservation {
   --ci-green:       #86cd53;
   --ci-green-dark:  #6ab53e;
   --ci-green-light: #f0faeb;
   --charcoal:       #1c1c1c;
   --text-main:      #1c1c1c;
   --text-sub:       #5a5a5a;
   --gray-50:        #fafaf8;
   --gray-100:       #f5f5f5;
   --gray-200:       #e8e8e8;
   --gray-400:       #aaaaaa;
   --red:            #e74c3c;
   --blue:           #3498db;
   --radius-sm:      8px;
   --radius-md:      14px;
   --shadow-sm:      0 1px 6px rgba(0,0,0,0.07);
   --shadow-md:      0 4px 20px rgba(0,0,0,0.10);
  
   background: var(--gray-50);
   font-family: 'Noto Sans KR', sans-serif;
   margin: 4rem 0;
 }
  
  
 /* ================================================
   # 페이지 타이틀
 ================================================ */
 #reservation .m-title {
   background: var(--charcoal);
   border-radius: var(--radius-md);
   padding: 2rem 1.5rem 1.5rem;
   margin-bottom: 1.5rem;
 }
 #reservation .m-title h3 {
   font-size: 1.5rem;
   font-weight: 700;
   color: #fff !important;
   text-decoration: none !important;
   letter-spacing: -0.3px;
   margin-bottom: 0.5rem;
 }
 #reservation .m-info {
   font-size: 0.95rem;
   color: rgba(255,255,255,0.65);
   background: transparent;
   line-height: 1.7;
 }
 #reservation .m-info .text-success {
   color: var(--ci-green) !important;
 }
 #reservation .m-info .text-primary {
   color: var(--ci-green) !important;
 }
  
 @media (max-width: 991px) {
   #reservation .m-info { font-size: 0.88rem; }
 }
  
  
 /* ================================================
   # 테이블 공통
 ================================================ */
 #reservation .table {
   vertical-align: middle;
 }
  
  
 /* ================================================
   # 예약상품 안내 (re-check)
 ================================================ */
 #reservation .re-check {
   background: #fff;
   border-radius: var(--radius-md);
   border: 1px solid var(--gray-200);
   box-shadow: var(--shadow-sm);
   overflow: hidden;
   margin-top: 0;
   margin-bottom: 1.2rem;
 }
 #reservation .re-check .title {
   text-align: left;
   color: #fff;
   background: var(--charcoal);
   font-size: 1.1rem;
   font-weight: 700;
   padding: 0.9rem 1.4rem;
   margin-bottom: 0;
   border-bottom: 3px solid var(--ci-green);
 }
 #reservation .re-check .table {
   border: none;
   margin-bottom: 0;
 }
 #reservation .re-check tr {
   font-size: 0.88rem;
   height: auto;
   border-bottom: 1px solid var(--gray-100);
 }
 #reservation .re-check tr:last-child { border-bottom: none; }
 #reservation .re-check .name {
   background: var(--gray-100);
   width: 130px;
   font-weight: 600;
   color: var(--text-sub);
   padding: 0.9rem 1rem;
 }
 #reservation .re-check td {
   text-align: left;
   padding: 0.9rem 1.4rem;
   color: var(--text-main);
 }
  
 @media (max-width: 991px) {
   #reservation .re-check .title { font-size: 1rem; }
   #reservation .re-check .name { font-size: 0.8rem; width: 90px; }
 }
  
  
 /* ================================================
   # 결제금액 (re-count)
 ================================================ */
 #reservation .re-count {
   background: var(--charcoal);
   border-radius: var(--radius-md);
   padding: 1.8rem 1.5rem;
   margin: 1.2rem 0;
 }
 #reservation .re-count .ro-final {
   margin-top: 0;
 }
 #reservation .re-count .ro-final p {
   font-size: 0.85rem;
   font-weight: 600;
   color: rgba(255,255,255,0.55);
   letter-spacing: 2px;
   margin-bottom: 0.4rem;
 }
 #reservation .re-count .ro-final .sum {
   font-size: 2.8rem;
   font-weight: 900;
   color: var(--ci-green) !important;
   letter-spacing: -1px;
   line-height: 1;
   margin-bottom: 0.8rem;
 }
 #reservation .re-count .ro-final .sum .text-secondary {
   font-size: 1.2rem;
   font-weight: 400;
   color: rgba(255,255,255,0.4) !important;
 }
 #reservation .re-count .ro-final hr {
   border-color: rgba(255,255,255,0.1);
 }
 #reservation .re-count .ro-final .op-ch {
   font-size: 0.75rem;
   color: rgba(255,255,255,0.35);
   font-weight: normal;
 }
  
 @media (max-width: 575px) {
   #reservation .re-count { padding: 1.4rem 1.2rem; }
   #reservation .re-count .ro-final .sum { font-size: 2.2rem; }
 }
  
  
 /* ================================================
   # 예약자 정보 (re-subsc)
 ================================================ */
 #reservation .re-subsc {
   background: #fff;
   border-radius: var(--radius-md);
   border: 1px solid var(--gray-200);
   box-shadow: var(--shadow-sm);
   padding: 1.4rem 1.5rem;
   margin-bottom: 1.2rem;
 }
 #reservation .re-subsc .title {
   font-size: 1rem;
   font-weight: 700;
   color: var(--text-main);
   padding-bottom: 0.8rem;
   border-bottom: 2px solid var(--ci-green);
   margin-bottom: 1rem;
 }
 #reservation .re-subsc table {
   border-top: none;
 }
 #reservation .re-subsc tr {
   border-color: var(--gray-100);
 }
 #reservation .re-subsc th {
   width: 110px;
   text-align: left;
   padding: 0.8rem 0.5rem;
   font-size: 0.82rem;
   font-weight: 600;
   color: var(--text-sub);
 }
 #reservation .re-subsc .form-control,
 #reservation .re-subsc .form-select {
   border: 1.5px solid var(--gray-200);
   border-radius: var(--radius-sm);
   height: 2.8rem;
   font-size: 0.9rem;
   transition: border-color 0.2s;
 }
 #reservation .re-subsc .form-control:focus,
 #reservation .re-subsc .form-select:focus {
   border-color: var(--ci-green);
   box-shadow: 0 0 0 3px rgba(134,205,83,0.15);
 }
 #reservation .re-subsc .form-control:disabled {
   background: var(--gray-100);
   color: var(--text-sub);
 }
 #reservation .re-subsc ::placeholder {
   color: var(--gray-400);
   font-size: 0.85rem;
 }
 #reservation .re-subsc .myself,
 #reservation .re-subsc .notme {
   font-size: 0.9rem;
   margin-left: 1rem;
 }
 #reservation .re-subsc .notme { margin-left: 2rem; }
 #reservation .re-subsc .input-group-text {
   background: transparent;
   border: none;
 }
  
 /* 여권 안내 */
 #reservation .re-subsc .notice {
   margin: 1rem 0 0;
   padding: 1rem 1.2rem;
   background: var(--gray-50);
   border-left: 4px solid var(--ci-green);
   border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
   font-size: 0.78rem;
   color: var(--text-sub);
 }
 #reservation .re-subsc .notice ul { padding-left: 0; margin: 0; }
 #reservation .re-subsc .notice li {
   list-style: none;
   line-height: 1.7;
   padding-left: 0.8rem;
   position: relative;
 }
 #reservation .re-subsc .notice li::before {
   content: '·';
   position: absolute;
   left: 0;
   color: var(--ci-green);
   font-weight: 700;
 }
  
 @media (max-width: 991px) {
   #reservation .re-subsc { padding: 1.2rem 1rem; margin-top: 0; }
   #reservation .re-subsc .title { font-size: 0.95rem; }
   #reservation .re-subsc th { font-size: 0.78rem; }
   #reservation .re-subsc .notme { font-size: 0.75rem; margin-left: 0.8rem; }
 }
  
  
 /* ================================================
   # 약관동의 (re-terms)
 ================================================ */
 #reservation .re-terms {
   background: #fff;
   border-radius: var(--radius-md);
   border: 1px solid var(--gray-200);
   box-shadow: var(--shadow-sm);
   padding: 1.4rem 1.5rem;
   margin-bottom: 1.2rem;
   text-align: left;
 }
 #reservation .re-terms .title {
   font-size: 1rem;
   font-weight: 700;
   color: var(--text-main);
   margin-bottom: 1rem;
 }
 #reservation .re-terms .form-check p {
   font-size: 1rem;
   font-weight: 700;
   color: var(--text-main);
   margin: -8px 0 8px 6px;
 }
 #reservation .re-terms .accordion-item {
   border: none !important;
   border-bottom: 1px solid var(--gray-100) !important;
 }
 #reservation .re-terms .accordion-item:last-child {
   border-bottom: none !important;
 }
 #reservation .re-terms .accordion-button {
   font-size: 0.88rem;
   font-weight: 600;
   color: var(--text-main);
   background: #fff;
   padding: 0.9rem 0.5rem;
   box-shadow: none;
   gap: 8px;
 }
 #reservation .re-terms .accordion-button:not(.collapsed) {
   color: var(--ci-green-dark);
   background: #fff;
 }
 #reservation .re-terms .accordion-body {
   font-size: 0.78rem;
   color: var(--text-sub);
   line-height: 1.7;
   background: var(--gray-100);
   border-radius: 0 0 var(--radius-sm) var(--radius-sm);
 }
 #reservation .re-terms .check {
   color: var(--red);
   font-weight: 700;
   padding: 0 5px 0 15px;
 }
 .form-check-input:checked {
   background-color: var(--ci-green);
   border-color: var(--ci-green);
 }
 .form-check-input:focus {
   border-color: var(--ci-green);
   box-shadow: 0 0 0 3px rgba(134,205,83,0.2);
 }
  
 @media (max-width: 991px) {
   #reservation .re-terms .title { font-size: 0.95rem; margin-bottom: 0.8rem; }
   #reservation .re-terms .form-check p { font-size: 0.9rem; }
 }
  
  
 /* ================================================
   # 필수 확인사항 (re-result)
 ================================================ */
 #reservation .re-result {
   margin-top: 0;
   margin-bottom: 1.2rem;
 }
 #reservation .re-result .bg-light {
   background: #fff7ed !important;
   border: 1px solid #fed7aa;
   border-radius: var(--radius-md);
 }
 #reservation .re-result .incont {
   padding: 1.2rem 1.4rem;
   text-align: left;
 }
 #reservation .re-result .incont p {
   font-size: 0.9rem;
   font-weight: 700;
   color: #9a3412;
   margin-bottom: 0.5rem;
 }
 #reservation .re-result ul { padding-left: 0; }
 #reservation .re-result ul li {
   list-style: none;
   font-size: 0.78rem;
   color: #7c2d12;
   line-height: 1.7;
 }
  
 @media (max-width: 991px) {
   #reservation .re-result .incont { padding: 1rem; }
   #reservation .re-result ul li { font-size: 0.72rem; }
 }
  
  
 /* ================================================
   # 쿠폰 테이블
 ================================================ */
 .couponTB {
   width: 100%;
   background: #fff;
   border-radius: var(--radius-md) !important;
   border: 1px solid var(--gray-200) !important;
   overflow: hidden;
 }
 .cpThName {
   background: var(--gray-100);
   font-size: 0.88rem;
   font-weight: 700;
   color: var(--text-main);
   padding: 1rem;
   vertical-align: middle;
   text-align: center;
   border-right: 1px solid var(--gray-200);
 }
 .couponTB td { padding: 0.5rem 1rem; }
 .noCoupon { font-size: 0.88rem; color: var(--text-sub); }
 .cpInfo { font-size: 0.88rem; font-weight: 600; color: var(--text-main); }
 .couponPrice { font-size: 0.88rem; font-weight: 700; color: var(--blue); }
 .couponExp { font-size: 0.78rem; color: var(--gray-400); }
 .couponRm { font-size: 0.75rem; color: var(--text-sub); }
  
  
 /* ================================================
   # 포인트 입력
 ================================================ */
 #reservation .availPoint {
   background: var(--gray-100);
   border: 1.5px solid var(--gray-200);
   border-radius: var(--radius-sm) 0 0 var(--radius-sm);
   font-size: 0.88rem;
   font-weight: 600;
   color: var(--text-main);
   padding: 0 1rem;
 }
 #reservation .usePBtn {
   background: var(--ci-green);
   border-color: var(--ci-green);
   color: #fff;
   font-weight: 700;
   transition: all 0.2s;
 }
 #reservation .usePBtn:hover {
   background: var(--ci-green-dark);
   border-color: var(--ci-green-dark);
 }
 #reservation .cxlPBtn {
   background: #f39c12;
   border-color: #f39c12;
   color: #fff;
   font-weight: 700;
 }
 #reservation .form-control:focus {
   border-color: var(--ci-green);
   box-shadow: 0 0 0 3px rgba(134,205,83,0.15);
 }
  
  
 /* ================================================
   # 예약/결제 버튼 (cxl, go, part)
 ================================================ */
 #reservation .cxl,
 #reservation .go,
 #reservation .part {
   --bs-btn-padding-y: 0;
   margin: 2rem 0.3rem;
   border-radius: var(--radius-sm);
   font-size: 1rem;
   font-weight: 700;
   transition: all 0.22s ease;
   padding: 14px 10px;
 }
 #reservation .cxl {
   background: var(--gray-100);
   color: var(--text-sub);
   border: 1.5px solid var(--gray-200);
 }
 #reservation .cxl:hover {
   background: var(--gray-200);
   border-color: var(--gray-400);
 }
 #reservation .go {
   background: var(--charcoal);
   color: #fff;
   border: none;
   box-shadow: 0 4px 14px rgba(0,0,0,0.15);
 }
 #reservation .go:hover {
   background: #333;
   transform: translateY(-2px);
   box-shadow: 0 8px 20px rgba(0,0,0,0.2);
 }
 #reservation .part {
   background: #172b83;
   color: #fff;
   border: none;
   box-shadow: 0 4px 14px rgba(23,43,131,0.25);
 }
 #reservation .part:hover {
   background: #1e3ea0;
   transform: translateY(-2px);
 }
  
 @media (max-width: 991px) {
   #reservation .cxl,
   #reservation .go,
   #reservation .part {
     margin: 0.4rem 0.3rem;
     font-size: 0.85rem;
     padding: 10px 8px;
     width: 100px;
   }
 }
  
  
 /* ================================================
   # 결제선택 버튼 (selPayBtn)
 ================================================ */
 .selPayBtn {
   text-align: center !important;
   padding: 1.5rem 0;
 }
 #reservation .selPayBtn .btn.btn-success {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 14px 32px;
   background: #27ae60;
   border: none;
   border-radius: var(--radius-sm);
   font-size: 1rem;
   font-weight: 700;
   color: #fff;
   box-shadow: 0 4px 14px rgba(39,174,96,0.3);
   transition: all 0.22s ease;
 }
 #reservation .selPayBtn .btn.btn-success:hover {
   background: #219a52;
   transform: translateY(-2px);
   box-shadow: 0 8px 20px rgba(39,174,96,0.4);
 }
 #reservation .selPayBtn .btn.btn-secondary {
   padding: 14px 20px;
   border-radius: var(--radius-sm);
   font-size: 0.9rem;
   font-weight: 600;
   transition: all 0.2s;
 }
  
  
 /* ================================================
   # 최종 결제하기 버튼 (btn-primary / doPay)
 ================================================ */
 #reservation .btn.btn-primary {
   background: var(--ci-green) !important;
   border-color: var(--ci-green) !important;
   color: var(--charcoal) !important;
   font-size: 1.05rem;
   font-weight: 700;
   border-radius: var(--radius-sm);
   box-shadow: 0 4px 16px rgba(134,205,83,0.35);
   transition: all 0.22s ease;
   padding: 14px 20px;
 }
 #reservation .btn.btn-primary:hover {
   background: var(--ci-green-dark) !important;
   border-color: var(--ci-green-dark) !important;
   transform: translateY(-2px);
   box-shadow: 0 8px 24px rgba(134,205,83,0.45);
 }
  
  
 /* ================================================
   # 모바일
 ================================================ */
 @media (max-width: 768px) {
     .couponTB { width: 100%; }
   .cpThName { font-size: 0.78rem; }
   .noCoupon { font-size: 0.72rem; }
   .cpInfo { font-size: 0.72rem; }
   .couponPrice { font-size: 0.72rem; }
   .couponExp { font-size: 0.68rem; }
   .couponRm { font-size: 0.68rem; }
   #reservation .availPoint,
   #reservation .usePBtn,
   #reservation .cxlPBtn { font-size: 0.8rem; font-weight: 600; }
   .selPayBtn {
     font-size: 0.85rem;
     padding: 0.5rem 0;
     text-align: center !important;
   }
   #reservation .selPayBtn .btn.btn-success { font-size: 0.85rem; padding: 12px 16px; }
   #reservation .btn.btn-primary { font-size: 0.95rem; }
   .d-flex.justify-content-left { flex-wrap: wrap !important; align-items: flex-start; }
   .form-check-input { margin-right: 6px; vertical-align: middle; }
 }
 </style>